// Define the LinkedProducts class
class LinkedProducts {
  /*
  * ##################################
  * CONSTRUCTOR & DATA INITIALIZATION
  * ##################################
  */
  constructor(scriptId) {
    this.scriptId = scriptId // The ID of the script tag to fetch data from
    this.data = null // The fetched data

    // Store references to the DOM elements we'll manipulate
    this.product = document.querySelector('[data-linked-product]')
    this.linked_containers_list = this.product && [...this.product.querySelectorAll('[data-linked-product-container]')]
    this.color_container = this.product && this.product.querySelector('[data-linked-product-color-container]')
    this.productTitle = this.product && this.product.querySelector('[data-product-title]')
    this.productBreadcrumb = this.product && this.product.querySelector('[data-product-breadcrumb]')
    this.productSKU = this.product && this.product.querySelector('[data-product-sku]')
    this.productAccordionReviews = this.product && this.product.querySelector('[data-accordion-reviews-content]')
    this.productShortDescription = this.product && this.product.querySelector('[data-short-description]')
    this.productPrice = this.product && this.product.querySelector('[data-product-price]')
    this.productComparePrice = this.product && this.product.querySelector('[data-compare-price]')
    this.defaultCompareAtPrice = this.product.compareAtPriceLabel;
    this.defaultOurPrice = this.product.regularPriceLabel;
    this.productBadgeDiscount = this.product && this.product.querySelector('[data-badge-discount]')
    this.productStockMessage = this.product && this.product.querySelector('[data-stock-message]')
    this.productAvailableElement = this.product && this.product.querySelector('[data-product-available]')
    this.productSoldOutElement = this.product && this.product.querySelector('[data-product-soldout]')
    this.productAddonsContainer = this.product && this.product.querySelector('[data-product-addons]')
    this.productAddonsHeading = this.product && this.product.querySelector('[data-product-addons-heading]')
    this.productColorLabel = this.product && this.product.querySelector('[data-color-label]')
    this.activeLabels = this.product && [...this.product.querySelectorAll('[data-linked-label]')]
    this.productId = this.product && this.product.querySelector('input[name="id"]')
    this.productImages = this.product && this.product.querySelector('[data-product-images]')
    this.productThumbs = this.product && this.product.querySelector('[data-product-thumbs]')
    this.productHighlights = this.product && document.querySelector('[data-product-highlights]')
    this.whatsIncluded = this.product && document.querySelector('[data-whats-included]')
    this.productInfoCards = this.product && document.querySelectorAll('[data-product-info-card]')
    this.productFeatures = this.product && document.querySelector('product-features')
    this.productCollectionVideo = this.product && document.querySelector('[data-product-collection-video]')
    this.inStockMessageElement = this.product && this.product.querySelector('[data-stock-message]')
    this.productRecentlyAddedContainer = this.product && document.querySelector('[data-recently-added-container]')
    this.productRecentlyAddedCount = this.product && document.querySelector('[data-recently-added-count]')
    this.calloutTextOne = this.product && document.querySelectorAll('[data-callout-one]')
    this.calloutTextTwo = this.product && document.querySelectorAll('[data-callout-two]')
    this.calloutTextThree = this.product && document.querySelectorAll('[data-callout-three]')
    this.aboveTitleText = this.product && this.product.querySelector('[data-above-title-text]')
    this.defaultCompareAtPrice = window.shopifyThemeSettings.comparePriceLabel
    this.defaultOurPrice = window.shopifyThemeSettings.regularPriceLabel
    this.productOverlayBadge = document.querySelector('.product-gallery__overlay-badge');
    this.productOverlayBadgeText = document.querySelector('.product-gallery__overlay-badge-text');
    this.productDescription = this.product && this.product.querySelector('[data-description]')
    this.productDescriptionMetafield = this.product && this.product.querySelectorAll('[data-short-description-metafield]')
    this.stickyAtcContainer = this.product && document.querySelector('[data-sticky-atc]')
    this.freeGiftWrappers = document.querySelectorAll('[data-free-gift-wrapper]')
    this.rebuyLinkedProductWidgets = document.querySelectorAll('[data-rebuy-linked-product-widget]')
  }

  // Method to fetch and parse linked product data from the script tag
  initializeData() {
    const scriptTag = document.getElementById(this.scriptId)
    if (scriptTag) {
      try {
        this.data = JSON.parse(scriptTag.innerHTML)
      } catch (e) {
        console.error('Error parsing JSON data from script tag:', e)
      }
    }
  }

  getOptions(optionsObj){
    if (!this.data.products || !this.data.products.every((product) => product.variants)) return {}

    for (const option in optionsObj) {
      const array = []
    this.data.products.forEach((product) => {
      const { metafields } = product
        array.push(metafields[option])
      })
      const updated_array =[... new Set(array.map(obj => JSON.stringify(obj)))].map(str => JSON.parse(str))
      optionsObj[option] = [...updated_array]
    }


    return optionsObj
  }

  // Method to retrieve product level addon products from linked product data
  getAddonOptions() {
    // Ensure there are products and each has variants
    if (!this.data.products || !this.data.products.every((product) => product.variants)) return []
    // Extract addon options
    const addonOptions = this.data.products.map((product) => product.addons)
    return Array.from(new Set(addonOptions)) // Remove duplicates
  }

  /*
  * ##################################
  * DOM MANIPULATION AND EVENT HANDLING
  * ##################################
  */

  handleOptionClick(event) {
    const clicked_option = event.currentTarget
    const clicked_option_value = event.currentTarget.getAttribute('data-value')
    const clicked_option_type = event.currentTarget.getAttribute('data-option-type')

    let state = {...this.active_labels_obj}

    state[clicked_option_type] = clicked_option_value

    // find the product from JSON data with the matching state
    let matchingProduct = this.getMatchingProduct(state)

    if(!matchingProduct.available){
      matchingProduct = this.getFirstProductOfType(clicked_option_type, clicked_option_value)
      const { metafields } = matchingProduct
      state = {...this.active_labels_obj}
      for (let key in state) {
        state[key] = metafields[key]?.value
      }
    }

    this.updateURL(state, matchingProduct) // Update the URL to reflect clicked state
    this.updateConditionalInfoCards(matchingProduct) // Hide product-specific content from the initially rendered sibling
    this.updateProductDetails(matchingProduct, state[clicked_option_type]) // Update the product details
    this.updatePageState(state) // Update the page state to reflect clicked state
    this.updateATCState(clicked_option) // Update the ATC button state
    this.renderAddonProductOptions()
  }

  handleOptionKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    event.currentTarget.click()
  }

  handleButtonRadioKeydown(event) {
    const currentOption = event.currentTarget
    const radiogroup = currentOption.closest('[role="radiogroup"]')
    if (!radiogroup) return

    const options = [...radiogroup.querySelectorAll('button[role="radio"]')]
      .filter((option) => !option.disabled && option.getAttribute('aria-disabled') !== 'true')
    const currentIndex = options.indexOf(currentOption)
    if (currentIndex === -1) return

    let nextIndex
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + options.length) % options.length
        break
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % options.length
        break
      case 'Home':
        nextIndex = 0
        break
      case 'End':
        nextIndex = options.length - 1
        break
      default:
        return
    }

    event.preventDefault()

    const nextOption = options[nextIndex]
    const optionType = nextOption.dataset.optionType
    const optionValue = nextOption.dataset.value

    if (nextOption === currentOption) return

    options.forEach((option) => {
      option.setAttribute('tabindex', option === nextOption ? '0' : '-1')
    })

    // Selecting a linked product rebuilds its option buttons. Restore focus to
    // the newly rendered version of the option after that update completes.
    nextOption.click()
    window.requestAnimationFrame(() => {
      const updatedContainer = this.linked_containers_obj?.[optionType]
      const updatedOption = updatedContainer && [...updatedContainer.querySelectorAll('button[role="radio"]')]
        .find((option) => option.dataset.value === optionValue)
      updatedOption?.focus({ preventScroll: true })
    })
  }

  handleUnavailableOptionClick(event, that) {
    const clicked_option = event.currentTarget
    const clicked_option_value = event.currentTarget.getAttribute('data-value')
    const clicked_option_type = event.currentTarget.getAttribute('data-option-type')
    const top_level_option = {[clicked_option_type]: clicked_option_value}
    const matchingProduct = that.getMatchingProduct(top_level_option)
    const { metafields } = matchingProduct
    let state = {...that.active_labels_obj}
    for (let key in state) {
      state[key] = metafields[key]?.value
    }

    that.updateURL(state, matchingProduct) // Update the URL to reflect clicked state
    that.updateConditionalInfoCards(matchingProduct) // Hide product-specific content from the initially rendered sibling
    that.updateProductDetails(matchingProduct, state[clicked_option_type]) // Update the product details
    that.updatePageState(state) // Update the page state to reflect clicked state
    that.updateATCState(clicked_option) // Update the ATC button state
    that.renderAddonProductOptions()
  }

  getMatchingProduct(state){
    let array = [...this.data.products]
    for(const option in state) {
      const filtered = array.filter((product) => {
       return product.metafields[option].value === state[option]
      })
      array = filtered
    }
    if (array[0]) return array[0]
  }

  isOptionAvailable(state, top_level_option){
    let array = [...this.data.products]
    let is_available = false
    const top_level_type = Object.keys(state).find(key => state[key] === top_level_option);
    for(const index in array){
      if(array[index].metafields[top_level_type]?.value === top_level_option && array[index].available){
        is_available = true
      }
    }
    return is_available
  }

  getFirstProductOfType(clicked_option_type, clicked_option_value){
    const new_state = {[clicked_option_type]: clicked_option_value}
    let array = [...this.data.products]
    for(const option in new_state) {
      const filtered = array.filter((product) => {
       return product.metafields[option].value === new_state[option] && product.available
      })
      array = filtered
    }
    if (array[0]) return array[0]
  }

  // Method to update the browser's URL to reflect the selected option
  updateURL(state, matchingProduct) {
    // @todo: Technical Debt for GP5 landing page. Remove
    if (document.body.dataset.preserveProductLandingUrl === 'true') return

    const newUrl = this.buildNewUrl(state, matchingProduct) // Generate a new URL based on the state
    history.pushState(state, '', newUrl) // Update the browser's URL
  }

  // Temporary safeguard for Liquid sections that are specific to the initially rendered product.
  // Restore them when the shopper returns to that product in the sibling selector.
  updateConditionalInfoCards(matchingProduct) {
    if (!matchingProduct) return

    document.querySelectorAll('[data-hide-on-sibling-switch]').forEach((element) => {
      const section = element.closest('.shopify-section') || element
      const isInitialProduct = element.dataset.initialProductId === String(matchingProduct.id)
      section.hidden = !isInitialProduct
    })
  }

  // Method to clear the active state from color options
  clearActiveOption(type) {
    const container = this.linked_containers_obj[type]
    if (!container) return

    if(type === 'color'){
      const activeOption = container.querySelector('input:checked')
      const activeSwatch = activeOption && activeOption.closest('.swatch-element')
      if (activeOption) activeOption.checked = false
      if (activeSwatch) activeSwatch.setAttribute('aria-checked', 'false')
    } else {
      const activeOption = container.querySelector('button.active')
      activeOption?.classList.remove('active')
      activeOption?.classList.add('inactive')
      activeOption?.setAttribute('aria-checked', 'false')
    }
  }

  // Method to set the clicked option as the active one
  updateActiveOption(clickedOption, type) {
    if (!clickedOption) return
    this.clearActiveOption(type) // First clear the active state
    if (type === 'color') {
      let selectedIndex = clickedOption.dataset.index
      clickedOption.checked = true // Then set the clicked option as active
      const swatchElement = clickedOption.closest('.swatch-element')
      swatchElement?.setAttribute('aria-checked', 'true')
      this.productColorLabel?.setAttribute('data-color-label', clickedOption.value)
      this.productColorLabel?.setAttribute('data-selected-index', selectedIndex)
      if (this.active_label_els[type]) this.active_label_els[type].textContent = clickedOption.value
    } else {
      clickedOption.classList.add('active')
      clickedOption.classList.remove('inactive')
      clickedOption.setAttribute('aria-checked', 'true')
      if (this.active_label_els[type]) this.active_label_els[type].textContent = clickedOption.dataset.value
    }
  }

  syncOptionAriaStates() {
    if (!this.linked_containers_obj || !this.active_labels_obj) return

    for (const type in this.linked_containers_obj) {
      const container = this.linked_containers_obj[type]
      const selectedValue = this.active_labels_obj[type]
      if (!container || !selectedValue) continue

      if (type === 'color') {
        container.querySelectorAll('.swatch-element[role="radio"]').forEach((swatchElement) => {
          const input = swatchElement.querySelector('input')
          const isSelected = swatchElement.dataset.value === selectedValue
          swatchElement.setAttribute('aria-checked', isSelected ? 'true' : 'false')
          if (input) input.checked = isSelected
        })
      } else {
        container.querySelectorAll('button[role="radio"]').forEach((button) => {
          const isSelected = button.dataset.value === selectedValue
          button.setAttribute('aria-checked', isSelected ? 'true' : 'false')
          button.setAttribute('tabindex', isSelected ? '0' : '-1')
          button.classList.toggle('active', isSelected)
          button.classList.toggle('inactive', !isSelected)
        })
      }
    }
  }

  updateStickyAtcContainer(matchingProduct){
    if(this.stickyAtcContainer){
      let stickyTitle = this.stickyAtcContainer.querySelector('.sticky-atc__title') || null;
      stickyTitle && matchingProduct.title ? stickyTitle.innerText = matchingProduct.title : null;

      let stickyImage = this.stickyAtcContainer.querySelector('.sticky-atc__image-wrapper img') || null;
      if(stickyImage && matchingProduct.media){
        stickyImage.src = matchingProduct.media[1].src.src
        stickyImage.setAttribute('srcset', matchingProduct.media[1].datasrc)
      }

      let stickyPrice = this.stickyAtcContainer.querySelector('[data-product-price]')
      let stickyComparePrice = this.stickyAtcContainer.querySelector('[data-compare-price]')

      if (stickyPrice && matchingProduct && matchingProduct.variants) {
        let variant = matchingProduct.variants[0]; // We're taking the first variant for this example
        const srSaleEl = document.querySelector('[data-sr-sale]');
    
        // Retrieve labels from metafields, providing defaults
        const ourPriceLabel = matchingProduct.regularPriceLabel || this.defaultOurPrice;
        const suggestedPriceLabel = matchingProduct.compareAtPriceLabel || this.defaultCompareAtPrice;
    
        // Check if price is properly defined and convert it to a number
        let price = variant.price;
        if (typeof price === 'string') {
          price = parseFloat(price.replace(/[^0-9.-]+/g, ''));
        }
    
        // Check if compare price is properly defined and convert it to a number
        let comparePrice = variant.compare_at_price;
        if (comparePrice && typeof comparePrice === 'string') {
          comparePrice = parseFloat(comparePrice.replace(/[^0-9.-]+/g, ''));
        }
    
        // Format prices as strings with dollar signs
        let formattedPrice = '$' + (Number.isInteger(price) ? price.toFixed(0) : price.toFixed(2));
    
        // Ensure 'deal' class is always present
        this.productPrice.classList.add('deal');
    
        // Check if compare price is present and different from the actual price
        if (comparePrice && comparePrice !== price) {
          let formattedComparePrice = '$' + (Number.isInteger(comparePrice) ? comparePrice.toFixed(0) : comparePrice.toFixed(2));
          stickyPrice.textContent = ourPriceLabel + ' ' + formattedPrice; // Update the price
          stickyPrice.classList.remove('no-sale'); // Remove 'no-sale' because it's on sale
    
          if (stickyComparePrice) {
            stickyComparePrice.textContent = suggestedPriceLabel + ' ' + formattedComparePrice;
            // stickyComparePrice.style.display = 'inline';
          }
    
          // Ensure sale price element is created if not already present
          if (!srSaleEl) {
            const newSrSaleEl = document.createElement('p');
            newSrSaleEl.setAttribute('data-sr-sale', '');
            newSrSaleEl.textContent = 'Sale Price';
            newSrSaleEl.classList.add('sr-only');
            stickyPrice.insertAdjacentElement('beforebegin', newSrSaleEl);
          }
        } else {
          // If not on sale, display only the regular price without the label
          this.productPrice.textContent = formattedPrice;
          this.productPrice.classList.add('no-sale'); // Add 'no-sale' because it's not on sale
    
          if (this.productComparePrice) {
            this.productComparePrice.style.display = 'none';
          }
          if (srSaleEl) {
            srSaleEl.remove();
          }
        }
      }
    }
  }

  // A unified method to update all the product details
  updateProductDetails(matchingProduct) {
    if (matchingProduct) {
      const pfasVisible = matchingProduct.metafields?.hide_pfas_visibility_on_product !== true
      if (typeof window.setPfasVisibility === 'function') {
        window.setPfasVisibility(pfasVisible)
      } else {
        window.pfasVisible = pfasVisible
      }

      this.updateProductTitle(matchingProduct)
      this.updateProductBreadcrumb(matchingProduct)
      this.updateProductDescription(matchingProduct)
      this.updateProductSku(matchingProduct)
      this.updateProductAccordionReviews(matchingProduct)
      this.updateProductPrice(matchingProduct)
      this.updateProductBadgeDiscount(matchingProduct)
      this.updateProductId(matchingProduct)
      !document.querySelector('.main-product') ? this.updateProductImages(matchingProduct) : this.updateProductImagesV2(matchingProduct);
      this.updateProductThumbs(matchingProduct)
      this.updateProductInfoCard(matchingProduct)
      this.updateProductFeatures(matchingProduct)
      this.updateProductCollectionVideo(matchingProduct)
      this.updateInStockMessage(matchingProduct)
      this.updateProductCallouts(matchingProduct)
      this.updateAboveTitleText(matchingProduct)
      this.updateRecentlyAddedCount(matchingProduct)
      this.renderLinkedProductOptions(matchingProduct)
      this.updateStickyAtcContainer(matchingProduct)
      
      if (matchingProduct.type == 'bundle') {
        
        this.updateBundleJSON(matchingProduct)
          .then(() => {
            const event = new CustomEvent('linked-product:updated')
            document.dispatchEvent(event)
          })
          .catch(error => {
            console.error('Error updating bundle:', error)
          })
      }
      
      this.updateProductHighlights(matchingProduct)
      // GP-869 A/B test: remove this dispatch once the highlight-inject test wins/completes
      document.dispatchEvent(new CustomEvent('product-highlights:updated'))
      this.updateWhatsIncluded(matchingProduct)
      this.updateProductOverlayBadge(matchingProduct);
      this.updateFreeGiftWrappers(matchingProduct);
      this.refreshRebuyLinkedProductWidget(matchingProduct)
      document.dispatchEvent(new CustomEvent('linked-product:updated', { detail: { product: matchingProduct } }))
    }
  }

  refreshRebuyLinkedProductWidget(matchingProduct) {
    if (!matchingProduct || !matchingProduct.id) {
      this.logRebuyLinkedProductWidget('skip: missing matching product id', matchingProduct)
      return
    }

    const currentWidgets = document.querySelectorAll('[data-rebuy-linked-product-widget]')
    if (!currentWidgets.length) {
      this.logRebuyLinkedProductWidget('skip: widget elements not found')
      return
    }

    const nextProductId = String(matchingProduct.id)

    let refreshedCount = 0
    currentWidgets.forEach(currentWidget => {
      const previousProductId = currentWidget.getAttribute('data-rebuy-shopify-product-ids')
      if (previousProductId === nextProductId) {
        this.logRebuyLinkedProductWidget('skip widget: product id unchanged', {
          productId: nextProductId,
          widgetId: currentWidget.getAttribute('data-rebuy-id')
        })
        return
      }

      const refreshedWidget = currentWidget.cloneNode(false)
      const widgetId = refreshedWidget.getAttribute('data-rebuy-id')
      refreshedWidget.setAttribute('data-rebuy-shopify-product-ids', nextProductId)
      currentWidget.replaceWith(refreshedWidget)
      this.unregisterRebuyWidget(widgetId)
      refreshedCount += 1

      this.logRebuyLinkedProductWidget('refresh requested', {
        previousProductId,
        nextProductId,
        widgetId,
        rebuyKeys: window.Rebuy ? Object.keys(window.Rebuy) : []
      })

      document.dispatchEvent(new CustomEvent('greenpan:rebuy-linked-product-widget:refresh', {
        detail: {
          productId: nextProductId,
          widgetId
        }
      }))
    })

    this.rebuyLinkedProductWidgets = document.querySelectorAll('[data-rebuy-linked-product-widget]')

    if (!refreshedCount) {
      return
    }

    this.reinitializeRebuyLinkedProductWidget()
  }

  unregisterRebuyWidget(widgetId) {
    const rebuy = window.Rebuy
    if (!rebuy || !widgetId) return

    if (Array.isArray(rebuy.widgets)) {
      rebuy.widgets = rebuy.widgets.filter(widget => String(widget && widget.id) !== String(widgetId))
    }
  }

  reinitializeRebuyLinkedProductWidget(attempt = 0) {
    const rebuy = window.Rebuy

    if (rebuy && typeof rebuy.reinit === 'function') {
      this.logRebuyLinkedProductWidget('calling Rebuy.reinit')
      rebuy.reinit()
      this.logRebuyLinkedProductWidgetState()
      return
    }

    if (rebuy && typeof rebuy.init === 'function' && rebuy.modules && rebuy.modules.Widgets) {
      this.logRebuyLinkedProductWidget('calling Rebuy.init')
      rebuy.init()
      this.logRebuyLinkedProductWidgetState()
      return
    }

    if (rebuy && rebuy.Widgets && typeof rebuy.Widgets.reinit === 'function') {
      this.logRebuyLinkedProductWidget('calling Rebuy.Widgets.reinit')
      rebuy.Widgets.reinit()
      this.logRebuyLinkedProductWidgetState()
      return
    }

    if (rebuy && rebuy.Widgets && typeof rebuy.Widgets.init === 'function') {
      this.logRebuyLinkedProductWidget('calling Rebuy.Widgets.init')
      rebuy.Widgets.init()
      this.logRebuyLinkedProductWidgetState()
      return
    }

    if (rebuy && rebuy.widget && typeof rebuy.widget.init === 'function') {
      this.logRebuyLinkedProductWidget('calling Rebuy.widget.init')
      rebuy.widget.init()
      this.logRebuyLinkedProductWidgetState()
      return
    }

    if (attempt < 10) {
      this.logRebuyLinkedProductWidget('waiting for Rebuy widget API', { attempt })
      setTimeout(() => this.reinitializeRebuyLinkedProductWidget(attempt + 1), 100)
    } else {
      this.logRebuyLinkedProductWidget('failed: Rebuy widget API unavailable', {
        rebuy: rebuy || null
      })
    }
  }

  logRebuyLinkedProductWidget(message, data = {}) {
    if (window.localStorage && window.localStorage.getItem('greenpanRebuyDebug') === 'true') {
      console.log('[GreenPan Rebuy linked widget]', message, data)
    }
  }

  logRebuyLinkedProductWidgetState() {
    if (!window.localStorage || window.localStorage.getItem('greenpanRebuyDebug') !== 'true') return

    setTimeout(() => {
      const widgets = [...document.querySelectorAll('[data-rebuy-linked-product-widget]')]
      this.logRebuyLinkedProductWidget('post-reinit state', {
        widgets: widgets.map(widget => ({
          widgetId: widget.getAttribute('data-rebuy-id'),
          productId: widget.getAttribute('data-rebuy-shopify-product-ids'),
          childCount: widget.childElementCount,
          htmlPreview: widget.innerHTML.slice(0, 160)
        })),
        registeredWidgetIds: Array.isArray(window.Rebuy && window.Rebuy.widgets)
          ? window.Rebuy.widgets.map(widget => widget && widget.id)
          : []
      })
    }, 1000)
  }

  // Method to update the product title based on the selected color
  updateProductTitle(matchingProduct) {
    if (this.productTitle && matchingProduct) {
      this.productTitle.textContent = matchingProduct.title // update the title
    }
  }

  // Method to update the product breadcrumb based on the selected color
  updateProductBreadcrumb(matchingProduct) {
    if (this.productBreadcrumb && matchingProduct) {
      this.productBreadcrumb.textContent = matchingProduct.title // update the breadcrumb
    }
  }

  // Method to update the product description based on the selected color
  updateProductDescription(matchingProduct) {
    if (this.productDescription) {
      this.productDescription.innerHTML = matchingProduct.description
    }
    if (this.productDescriptionMetafield) {
      this.productDescriptionMetafield.forEach(field => {
        field.innerHTML = matchingProduct.short_description_metafield
      })
    }
  }  

  updateProductSku(matchingProduct) {
    if (this.productSKU && matchingProduct) {
      this.productSKU.innerHTML = "SKU " + matchingProduct.sku;
    }
  } 

  updateUgcAccordionTitle(titleText) {
    const toggleSet = new Set()

    document.querySelectorAll('[data-ugc-accordion-toggle]').forEach((toggle) => {
      toggleSet.add(toggle)
    })

    document.querySelectorAll('.accordion__toggle[data-button-id="ugc-button"]').forEach((toggle) => {
      toggleSet.add(toggle)
    })

    if (toggleSet.size === 0) {
      document.querySelectorAll('.accordion__toggle').forEach((toggle) => {
        const text = (toggle.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase()
        if (text === 'see what people think' || toggle.dataset.ugcTitle === 'true') {
          toggleSet.add(toggle)
        }
      })
    }

    toggleSet.forEach((toggle) => {
      let headingText = toggle.querySelector('[data-accordion-heading-text]')
      if (!headingText) {
        headingText = document.createElement('span')
        headingText.setAttribute('data-accordion-heading-text', '')
        const indicator = toggle.querySelector('[data-accordion-indicator]')
        toggle.insertBefore(headingText, indicator || toggle.firstChild)
      }

      headingText.textContent = titleText
      toggle.dataset.ugcTitle = 'true'
    })
  }
  
  updateProductAccordionReviews(matchingProduct) {
    if (!matchingProduct) return

    const overrideTitle = typeof matchingProduct.see_what_people_think_tab_title === 'string'
      ? matchingProduct.see_what_people_think_tab_title.trim()
      : ''
    const titleText = overrideTitle !== '' ? overrideTitle : 'See What People Think'

    this.updateUgcAccordionTitle(titleText)
    requestAnimationFrame(() => this.updateUgcAccordionTitle(titleText))

    if (this.productAccordionReviews) {
      if(matchingProduct.collection_reviews && matchingProduct.collection_reviews.length > 0) {
        let reviews = this.productAccordionReviews.querySelector('[data-reviews]')
        reviews.innerHTML = ""
        matchingProduct.collection_reviews.forEach(review => {
          this.productAccordionReviews.classList.contains('hide') ? this.productAccordionReviews.classList.remove('hide') : null
          let template = null
          if(review.review_content_complete.length > 100){
            template = `
            <div class="accordion-review">
            <div class="accordion-review__stars">
              <svg xmlns="http://www.w3.org/2000/svg" width="103" height="18" viewBox="0 0 103 18" fill="none">
                <path d="M19.3647 7.08123C19.2436 6.75346 18.9201 6.52755 18.5481 6.51105H12.702L10.8461 1.17203C10.714 0.814087 10.3427 0.581291 9.93675 0.601845C9.53935 0.599188 9.18612 0.837081 9.06448 1.18931L7.20857 6.52832H1.38103C0.989588 6.52582 0.640345 6.75681 0.514033 7.10176C0.387721 7.4467 0.512686 7.8282 0.824261 8.04882L5.55682 11.3835L3.70091 16.7571C3.56981 17.1099 3.70235 17.501 4.02717 17.7198C4.35199 17.9387 4.79245 17.9336 5.1114 17.7074L10.0667 14.2518L15.0405 17.7074C15.1954 17.8172 15.3841 17.8777 15.5787 17.8802C15.875 17.8841 16.1548 17.7533 16.3284 17.5297C16.502 17.3062 16.5478 17.0179 16.451 16.7571L14.5951 11.3835L19.2348 8.03154C19.485 7.77023 19.5366 7.39255 19.3647 7.08123Z" fill="#282828"/>
                <path d="M40.3647 7.08123C40.2436 6.75346 39.9201 6.52755 39.5481 6.51105H33.702L31.8461 1.17203C31.714 0.814087 31.3427 0.581291 30.9368 0.601845C30.5393 0.599188 30.1861 0.837081 30.0645 1.18931L28.2086 6.52832H22.381C21.9896 6.52582 21.6403 6.75681 21.514 7.10176C21.3877 7.4467 21.5127 7.8282 21.8243 8.04882L26.5568 11.3835L24.7009 16.7571C24.5698 17.1099 24.7023 17.501 25.0272 17.7198C25.352 17.9387 25.7924 17.9336 26.1114 17.7074L31.0667 14.2518L36.0405 17.7074C36.1954 17.8172 36.3841 17.8777 36.5787 17.8802C36.875 17.8841 37.1548 17.7533 37.3284 17.5297C37.502 17.3062 37.5478 17.0179 37.451 16.7571L35.5951 11.3835L40.2348 8.03154C40.485 7.77023 40.5366 7.39255 40.3647 7.08123Z" fill="#282828"/>
                <path d="M61.3647 7.08123C61.2436 6.75346 60.9201 6.52755 60.5481 6.51105H54.702L52.8461 1.17203C52.714 0.814087 52.3427 0.581291 51.9368 0.601845C51.5393 0.599188 51.1861 0.837081 51.0645 1.18931L49.2086 6.52832H43.381C42.9896 6.52582 42.6403 6.75681 42.514 7.10176C42.3877 7.4467 42.5127 7.8282 42.8243 8.04882L47.5568 11.3835L45.7009 16.7571C45.5698 17.1099 45.7023 17.501 46.0272 17.7198C46.352 17.9387 46.7924 17.9336 47.1114 17.7074L52.0667 14.2518L57.0405 17.7074C57.1954 17.8172 57.3841 17.8777 57.5787 17.8802C57.875 17.8841 58.1548 17.7533 58.3284 17.5297C58.502 17.3062 58.5478 17.0179 58.451 16.7571L56.5951 11.3835L61.2348 8.03154C61.485 7.77023 61.5366 7.39255 61.3647 7.08123Z" fill="#282828"/>
                <path d="M82.3647 7.08123C82.2436 6.75346 81.9201 6.52755 81.5481 6.51105H75.702L73.8461 1.17203C73.714 0.814087 73.3427 0.581291 72.9368 0.601845C72.5393 0.599188 72.1861 0.837081 72.0645 1.18931L70.2086 6.52832H64.381C63.9896 6.52582 63.6403 6.75681 63.514 7.10176C63.3877 7.4467 63.5127 7.8282 63.8243 8.04882L68.5568 11.3835L66.7009 16.7571C66.5698 17.1099 66.7023 17.501 67.0272 17.7198C67.352 17.9387 67.7924 17.9336 68.1114 17.7074L73.0667 14.2518L78.0405 17.7074C78.1954 17.8172 78.3841 17.8777 78.5787 17.8802C78.875 17.8841 79.1548 17.7533 79.3284 17.5297C79.502 17.3062 79.5478 17.0179 79.451 16.7571L77.5951 11.3835L82.2348 8.03154C82.485 7.77023 82.5366 7.39255 82.3647 7.08123Z" fill="#282828"/>
                <path d="M102.37 7.08123C102.255 6.75346 101.949 6.52755 101.596 6.51105H96.058L94.2998 1.17203C94.1746 0.814087 93.8228 0.581291 93.4383 0.601845C93.0618 0.599188 92.7271 0.837081 92.6119 1.18931L90.8537 6.52832H85.3328C84.962 6.52582 84.6311 6.75681 84.5115 7.10176C84.3918 7.4467 84.5102 7.8282 84.8054 8.04882L89.2888 11.3835L87.5306 16.7571C87.4064 17.1099 87.532 17.501 87.8397 17.7198C88.1474 17.9387 88.5647 17.9336 88.8669 17.7074L93.5613 14.2518L98.2734 17.7074C98.4201 17.8172 98.5989 17.8777 98.7833 17.8802C99.064 17.8841 99.329 17.7533 99.4935 17.5297C99.658 17.3062 99.7013 17.0179 99.6096 16.7571L97.8514 11.3835L102.247 8.03154C102.484 7.77023 102.533 7.39255 102.37 7.08123Z" fill="#282828"/>
                </svg>
            </div>
              <div class="accordion-review__heading">${review.review_heading}</div>
              <div class="accordion-review__content" data-accordion-reviews-content>
                <read-more-content class="collapsed">
                  <span data-truncated-review>${review.review_content_truncated}</span>
                  <span data-complete-review>${review.review_content_complete}</span>
                  <div>
                  <button>
                    <span data-read-more-indicator>
                      Read More
                    </span>
                    <span data-read-less-indicator>
                      Read Less
                    </span>
                  </button>
                  </div>
                </read-more-content>
              </div>
            `
          }else{
          template = `
            <div class="accordion-review">
            <div class="accordion-review__stars">
              <svg xmlns="http://www.w3.org/2000/svg" width="103" height="18" viewBox="0 0 103 18" fill="none">
                <path d="M19.3647 7.08123C19.2436 6.75346 18.9201 6.52755 18.5481 6.51105H12.702L10.8461 1.17203C10.714 0.814087 10.3427 0.581291 9.93675 0.601845C9.53935 0.599188 9.18612 0.837081 9.06448 1.18931L7.20857 6.52832H1.38103C0.989588 6.52582 0.640345 6.75681 0.514033 7.10176C0.387721 7.4467 0.512686 7.8282 0.824261 8.04882L5.55682 11.3835L3.70091 16.7571C3.56981 17.1099 3.70235 17.501 4.02717 17.7198C4.35199 17.9387 4.79245 17.9336 5.1114 17.7074L10.0667 14.2518L15.0405 17.7074C15.1954 17.8172 15.3841 17.8777 15.5787 17.8802C15.875 17.8841 16.1548 17.7533 16.3284 17.5297C16.502 17.3062 16.5478 17.0179 16.451 16.7571L14.5951 11.3835L19.2348 8.03154C19.485 7.77023 19.5366 7.39255 19.3647 7.08123Z" fill="#282828"/>
                <path d="M40.3647 7.08123C40.2436 6.75346 39.9201 6.52755 39.5481 6.51105H33.702L31.8461 1.17203C31.714 0.814087 31.3427 0.581291 30.9368 0.601845C30.5393 0.599188 30.1861 0.837081 30.0645 1.18931L28.2086 6.52832H22.381C21.9896 6.52582 21.6403 6.75681 21.514 7.10176C21.3877 7.4467 21.5127 7.8282 21.8243 8.04882L26.5568 11.3835L24.7009 16.7571C24.5698 17.1099 24.7023 17.501 25.0272 17.7198C25.352 17.9387 25.7924 17.9336 26.1114 17.7074L31.0667 14.2518L36.0405 17.7074C36.1954 17.8172 36.3841 17.8777 36.5787 17.8802C36.875 17.8841 37.1548 17.7533 37.3284 17.5297C37.502 17.3062 37.5478 17.0179 37.451 16.7571L35.5951 11.3835L40.2348 8.03154C40.485 7.77023 40.5366 7.39255 40.3647 7.08123Z" fill="#282828"/>
                <path d="M61.3647 7.08123C61.2436 6.75346 60.9201 6.52755 60.5481 6.51105H54.702L52.8461 1.17203C52.714 0.814087 52.3427 0.581291 51.9368 0.601845C51.5393 0.599188 51.1861 0.837081 51.0645 1.18931L49.2086 6.52832H43.381C42.9896 6.52582 42.6403 6.75681 42.514 7.10176C42.3877 7.4467 42.5127 7.8282 42.8243 8.04882L47.5568 11.3835L45.7009 16.7571C45.5698 17.1099 45.7023 17.501 46.0272 17.7198C46.352 17.9387 46.7924 17.9336 47.1114 17.7074L52.0667 14.2518L57.0405 17.7074C57.1954 17.8172 57.3841 17.8777 57.5787 17.8802C57.875 17.8841 58.1548 17.7533 58.3284 17.5297C58.502 17.3062 58.5478 17.0179 58.451 16.7571L56.5951 11.3835L61.2348 8.03154C61.485 7.77023 61.5366 7.39255 61.3647 7.08123Z" fill="#282828"/>
                <path d="M82.3647 7.08123C82.2436 6.75346 81.9201 6.52755 81.5481 6.51105H75.702L73.8461 1.17203C73.714 0.814087 73.3427 0.581291 72.9368 0.601845C72.5393 0.599188 72.1861 0.837081 72.0645 1.18931L70.2086 6.52832H64.381C63.9896 6.52582 63.6403 6.75681 63.514 7.10176C63.3877 7.4467 63.5127 7.8282 63.8243 8.04882L68.5568 11.3835L66.7009 16.7571C66.5698 17.1099 66.7023 17.501 67.0272 17.7198C67.352 17.9387 67.7924 17.9336 68.1114 17.7074L73.0667 14.2518L78.0405 17.7074C78.1954 17.8172 78.3841 17.8777 78.5787 17.8802C78.875 17.8841 79.1548 17.7533 79.3284 17.5297C79.502 17.3062 79.5478 17.0179 79.451 16.7571L77.5951 11.3835L82.2348 8.03154C82.485 7.77023 82.5366 7.39255 82.3647 7.08123Z" fill="#282828"/>
                <path d="M102.37 7.08123C102.255 6.75346 101.949 6.52755 101.596 6.51105H96.058L94.2998 1.17203C94.1746 0.814087 93.8228 0.581291 93.4383 0.601845C93.0618 0.599188 92.7271 0.837081 92.6119 1.18931L90.8537 6.52832H85.3328C84.962 6.52582 84.6311 6.75681 84.5115 7.10176C84.3918 7.4467 84.5102 7.8282 84.8054 8.04882L89.2888 11.3835L87.5306 16.7571C87.4064 17.1099 87.532 17.501 87.8397 17.7198C88.1474 17.9387 88.5647 17.9336 88.8669 17.7074L93.5613 14.2518L98.2734 17.7074C98.4201 17.8172 98.5989 17.8777 98.7833 17.8802C99.064 17.8841 99.329 17.7533 99.4935 17.5297C99.658 17.3062 99.7013 17.0179 99.6096 16.7571L97.8514 11.3835L102.247 8.03154C102.484 7.77023 102.533 7.39255 102.37 7.08123Z" fill="#282828"/>
                </svg>
            </div>
              <div class="accordion-review__heading">${review.review_heading}</div>
              <div class="accordion-review__content" data-accordion-reviews-content>
                 ${review.review_content_complete}
              </div
            </div>
            `
          }
          reviews.innerHTML += template
        })
        reviews.innerHTML += `
        <a class="read-more-button" href="#BVRRContainer">
          READ MORE REVIEWS
        </a>
        `
      }else {
        !this.productAccordionReviews.classList.contains('hide') ? this.productAccordionReviews.classList.add('hide') : null
      }
    }
  } 

  // Method to update the product price based on the selected color
  updateProductPrice(matchingProduct) {
    if (this.productPrice && matchingProduct && matchingProduct.variants) {
      let variant = matchingProduct.variants[0]; // We're taking the first variant for this example
      const srSaleEl = document.querySelector('[data-sr-sale]');

      // Retrieve labels from metafields, providing defaults
      const ourPriceLabel = matchingProduct.regularPriceLabel === null ? this.defaultOurPrice : matchingProduct.regularPriceLabel;
      const suggestedPriceLabel = matchingProduct.compareAtPriceLabel === null ? this.defaultCompareAtPrice : matchingProduct.compareAtPriceLabel;

      // Check if price is properly defined and convert it to a number
      let price = variant.price;
      if (typeof price === 'string') {
        price = parseFloat(price.replace(/[^0-9.-]+/g, ''));
      }
  
      // Check if compare price is properly defined and convert it to a number
      let comparePrice = variant.compare_at_price;
      if (comparePrice && typeof comparePrice === 'string') {
        comparePrice = parseFloat(comparePrice.replace(/[^0-9.-]+/g, ''));
      }
  
      // Format prices as strings with dollar signs
      let formattedPrice = '$' + (Number.isInteger(price) ? price.toFixed(0) : price.toFixed(2));
  
      // Ensure 'deal' class is always present
      this.productPrice.classList.add('deal');
  
      // Check if compare price is present and different from the actual price
      if (comparePrice && comparePrice !== price) {
        let formattedComparePrice = '$' + (Number.isInteger(comparePrice) ? comparePrice.toFixed(0) : comparePrice.toFixed(2));
        this.productPrice.textContent = ourPriceLabel + ' ' + formattedPrice; // Update the price
        this.productPrice.classList.remove('no-sale'); // Remove 'no-sale' because it's on sale
  
        if (this.productComparePrice) {
          this.productComparePrice.textContent = suggestedPriceLabel + ' ' + formattedComparePrice;
          this.productComparePrice.style.display = 'block';
        }
  
        // Ensure sale price element is created if not already present
        if (!srSaleEl) {
          const newSrSaleEl = document.createElement('p');
          newSrSaleEl.setAttribute('data-sr-sale', '');
          newSrSaleEl.textContent = 'Sale Price';
          newSrSaleEl.classList.add('sr-only');
          this.productPrice.insertAdjacentElement('beforebegin', newSrSaleEl);
        }
      } else {
        // If not on sale, display only the regular price without the label
        this.productPrice.textContent = formattedPrice;
        this.productPrice.classList.add('no-sale'); // Add 'no-sale' because it's not on sale
  
        if (this.productComparePrice) {
          this.productComparePrice.style.display = 'none';
        }
        if (srSaleEl) {
          srSaleEl.remove();
        }
      }
    }
  }  

  //Method to update the discount badge based on selected color
  updateProductBadgeDiscount(matchingProduct) {
    if (this.productBadgeDiscount && matchingProduct) {
      this.productBadgeDiscount.textContent = matchingProduct.badgeDiscount // update the breadcrumb
    }
  }

  //Method to update the hidden product variant id for adding to cart based on selected color
  updateProductId(matchingProduct) {
    if (this.productId && matchingProduct) {
      this.productId.value = matchingProduct.variants[0].id// update the variant id
    }
  }

  // update the main product image gallery
  updateProductImages(matchingProduct) {
    if (!this.productImages || !matchingProduct || !matchingProduct.media) return;

    const galleryTop = this.productImages;
    if (!galleryTop) return;

    let has_video = false
    matchingProduct.media.forEach((mediaItem, index) => {
      if(mediaItem.type == 'video' || mediaItem.type == 'external_video') {
        has_video = true
      }
    })

    let slides = matchingProduct.media.map((mediaItem, index) => {
      if (index === 0) mediaItem = matchingProduct.media[1];
      else if (index === 1) mediaItem = matchingProduct.media[0];

      let lazyClass = '';
      index === 0 ? lazyClass = ' lazy' : '';

      let paddingTopPercentage = (1 / mediaItem.aspect_ratio) * 100; // Calculate padding-top percentage
      if (mediaItem.type === 'image') {
        return `
                <div class="active-wrapper slide" data-media-id="${mediaItem.id}" style="padding-top: ${paddingTopPercentage}%">
                    ${index == 0 && has_video ? '<dynamic-play-button><button><span class="dynamic-svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none"><path d="M10.5312 6.53125L0.734376 12.1875L0.734377 0.875021L10.5312 6.53125Z" fill="#19341A"/></svg></span><span class="dynamic-video__text">Play Video</span></button></dynamic-play-button>' : null}
                    <a href="${mediaItem.master.src}" class="productImage">
                        <div>
                            <img
                                data-srcset="${mediaItem.datasrc}"
                                data-sizes="auto"
                                data-file="${mediaItem.master.src}"
                                class="large-thumb"
                                itemprop="image"
                                alt="${mediaItem.alt}"
                                height="650px"
                                width="650px"
                            >
                        </div>
                    </a>
                </div>
            `;
      } else if (mediaItem.type === 'video') {
        return `
                <div class="active-wrapper slide video-slide" data-media-id="${mediaItem.id}">
                    <video controls width="${mediaItem.width}" height="${mediaItem.height}">
                        <source src="${mediaItem.src}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            `;
      } else if (mediaItem.type === 'external_video' && mediaItem.host === 'vimeo') {
        return `
                <div class="active-wrapper slide external-video-slide" data-media-id="${mediaItem.id}">
                    <div class="video-wrap" style="padding-top: ${paddingTopPercentage}%">
                        <iframe src="https://player.vimeo.com/video/${mediaItem.external_id}" width="${mediaItem.width}" height="${mediaItem.height}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                </div>
            `;
      }
    });

    $('.main-images').slick('destroy');
    galleryTop.innerHTML = slides.join('');
    $('.main-images').slick('init');
    $('.main-images').slick('slickGoTo', 0);
  }

  updateProductImagesV2(matchingProduct) {
    if (!this.productImages || !matchingProduct || !matchingProduct.media) return;

    const galleryTop = this.productImages;
    if (!galleryTop) return;

    let has_video = false
    matchingProduct.media.forEach((mediaItem, index) => {
      if(mediaItem.type == 'video' || mediaItem.type == 'external_video') {
        has_video = true
      }
    })

    let slides = matchingProduct.media.map((mediaItem, index) => {
      if (index === 0) mediaItem = matchingProduct.media[1];
      else if (index === 1) mediaItem = matchingProduct.media[0];

      let lazy = '';
      index === 0 ? lazy = 'lazy' : lazy = 'eager';

      let paddingTopPercentage = (1 / mediaItem.aspect_ratio) * 100; // Calculate padding-top percentage

      if (mediaItem.type === 'image') {
        return `
                <div class="active-wrapper slide${index > 4 ? ' hide-initially-hidden initially-hidden-images': ''}" data-media-id="${mediaItem.id}" style="padding-top: ${paddingTopPercentage}%" data-index="${index}">
                    ${index == 0 && has_video ? '<dynamic-play-button><button><span class="dynamic-svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none"><path d="M10.5312 6.53125L0.734376 12.1875L0.734377 0.875021L10.5312 6.53125Z" fill="#19341A"/></svg></span><span class="dynamic-video__text">Play Video</span></button></dynamic-play-button>' : ''}
                    <a href="${mediaItem.master.src}" class="productImage">
                        <div>
                            <img
                                srcset="${mediaItem.datasrc}"
                                sizes="auto"
                                data-file="${mediaItem.master.src}"
                                class="large-thumb"
                                itemprop="image"
                                alt="${mediaItem.alt}"
                                height="700px"
                                width="700px"
                                loading="${lazy}"
                            >
                        </div>
                    </a>
                </div>
            `;
      } else if (mediaItem.type === 'video') {
        return `
                <div class="active-wrapper slide external-video-slide">
                <video-button>
                  <button class="video-wrap" data-html='${mediaItem.media_tag}'>
                  <div class="play-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="143" height="143" viewBox="0 0 143 143" fill="none">
                      <path d="M103.991 74.425L55.1365 102.631L55.1365 46.2188L103.991 74.425Z" fill="white"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M71.4209 135.235C106.662 135.235 135.23 106.666 135.23 71.425C135.23 36.184 106.662 7.61548 71.4209 7.61548C36.1798 7.61548 7.61133 36.184 7.61133 71.425C7.61133 106.666 36.1798 135.235 71.4209 135.235ZM71.4209 142.235C110.528 142.235 142.23 110.532 142.23 71.425C142.23 32.318 110.528 0.615479 71.4209 0.615479C32.3139 0.615479 0.611328 32.318 0.611328 71.425C0.611328 110.532 32.3139 142.235 71.4209 142.235Z" fill="white"/>
                    </svg>
                  </div>
                    <img src="${mediaItem.preview_image}">
                  </button>
                </video-button>
                </div>
            `;
      } else if (mediaItem.type === 'external_video' && mediaItem.host === 'vimeo') {
        return `
                <div class="active-wrapper slide external-video-slide">
                <video-button>
                  <button class="video-wrap" data-html='${mediaItem.media_tag}'>
                    <img src="${mediaItem.preview_image}">
                  </button>
                </video-button>
                </div>
            `;
      }
    });

    let isSlicked = document.querySelector(".main-product__images-wrapper.slick-initialized")
    let show_multicolumn = true

    if (matchingProduct.metafields?.disable_pdp_multicolumn === true) {
      show_multicolumn = false
    }

    const multicolumn_loader = "<multicolumn-loader class='multicolumn-gallery desktop'></multicolumn-loader>"

    if (multicolumn_loader && show_multicolumn) {
      slides.splice(3, 0, multicolumn_loader)
    }
    if(isSlicked) {
      $('.main-product__images-wrapper').slick('destroy');
      galleryTop.innerHTML = slides.join('');
      $('.main-product__images-wrapper').slick('init');
      $('.main-product__images-wrapper').slick('slickGoTo', 0);
    } else {
      let gallery_see_more  = document.querySelector('[data-see-more-button]');
      if(gallery_see_more){
        gallery_see_more.classList.contains('expanded') ? gallery_see_more.classList.remove('expanded'): null
      }
      galleryTop.innerHTML = slides.join('');
    }

    // Reinitialize PhotoSwipe
    if($('.active-wrapper a.productImage').length > 0) {
      $('.active-wrapper a.productImage, .active-wrapper iframe').photoSwipe({
        getDoubleTapZoom: function(isMouseClick, item) {
          return item.initialZoomLevel;
        },
        index: function() {
          return $(this).closest('.slide').index();
        },
        beforeOpen: function() {
          let slides = this.color_container.querySelectorAll('.pswp__item img');
          
          const clickedIndex = this.options.index();
          
          if (slides.length > 1) {
            const first = slides[0];
            const second = slides[1];
            second.parentNode.insertBefore(second, first);
          }
          if (slides.length > 2) {
            const third = slides[2];
            const second = slides[1];
            third.parentNode.insertBefore(third, second);
          }
          
          this.options.index = clickedIndex;
        }
      });
    }
  }

  updateProductThumbs(matchingProduct) {
    if (!this.productThumbs || !matchingProduct || !matchingProduct.media) return;
    let container = this.productThumbs;
    if (!container) return;

    let slides = matchingProduct.media.map((media, index) => {
      if (index === 0) media = matchingProduct.media[1];
      else if (index === 1) media = matchingProduct.media[0];

      let activeClass = index === 0 ? ' active' : '';

      if (media.type === 'image') {
        return `
                <div class="slide${activeClass}" data-media-type="image">
                    <a class="gallery" href="${media.src.src}" data-media-id="${media.id}" variant-id="" tabindex="0">
                        <img src="${media.src.src}" loading="lazy" alt="${media.alt}" width="198" height="198">
                    </a>
                </div>
            `;
      } else if (media.type === 'external_video') {
        return `
                <div class="slide${activeClass}" data-media-type="external_video">
                    <a class="gallery" href="#" data-media-id="${media.id}" variant-id="" tabindex="0">
                        <img src="${media.preview_image}" loading="lazy" alt="${media.alt}" width="198" height="198">
                    </a>
                </div>
            `;
      }
    });

    $('.thumbs').slick('destroy');
    container.innerHTML = slides.join('');
    $('.thumbs').slick({
      autoplay: false,
      speed: 700,
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      prevArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-up up-arrow" viewBox="0 0 32 32"><path fill="{{settings.content_text_color}}" d="M26.984 23.5l1.516-1.617L16 8.5 3.5 21.883 5.008 23.5 16 11.742z"/></svg>',
      nextArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-down down-arrow" viewBox="0 0 32 32"><path fill="{{settings.content_text_color}}" d="M26.984 8.5l1.516 1.617L16 23.5 3.5 10.117 5.008 8.5 16 20.258z"/></svg>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            swipeToSlide: true,
            vertical: false,
            verticalSwiping: false,
            arrows: false,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false,
            prevArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left left-arrow" viewBox="0 0 32 32"><path fill="{{settings.content_text_color}}" d="M24.333 28.205l-1.797 1.684L7.666 16l14.87-13.889 1.797 1.675L11.269 16z"/></svg>',
            nextArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right right-arrow" viewBox="0 0 32 32"><path fill="{{settings.content_text_color}}" d="M7.667 3.795l1.797-1.684L24.334 16 9.464 29.889l-1.797-1.675L20.731 16z"/></svg>'
          }
        }
      ]
    });
    const thumbs = document.querySelectorAll('.thumbs.switch a.gallery');
    if (thumbs) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('thumbnails:updated', { detail: { mediaId: thumb.getAttribute('data-media-id') } }));
        })
      })
    }
  }

  // Method to update the product info cards based on color selected
  updateProductInfoCard(matchingProduct) {
    if (!matchingProduct) return;

    // Query wrappers - supports both old and new markup
    const wrappers = document.querySelectorAll('[data-product-info-card-wrapper]');
    const legacyCards = this.productInfoCards;

    // If no new wrappers found, fall back to legacy cards behavior
    if (!wrappers || !wrappers.length) {
      if (!legacyCards || !legacyCards.length) return;
      // Legacy fallback - hide all if show_info_card is false
      const showInfoCard = matchingProduct.show_info_card === 'true' || matchingProduct.show_info_card === true;
      legacyCards.forEach((card) => {
        const parentContainer = card.closest('.container');
        if (parentContainer) {
          parentContainer.classList.toggle('hide', !showInfoCard);
        }
      });
      return;
    }

    const showInfoCardValue = matchingProduct.show_info_card;
    const showInfoCard = showInfoCardValue === 'true' || showInfoCardValue === true;
    const useVariantImage = matchingProduct.use_variant_info_image === true || matchingProduct.use_variant_info_image === 'true';
    const fullWidthMode = matchingProduct.info_card_full_width_image_only === true || matchingProduct.info_card_full_width_image_only === 'true';
    const hasContent = Array.isArray(matchingProduct.info_card) && matchingProduct.info_card.length > 0;

    // If variant-specific images are used, only handle visibility (don't rewrite markup)
    if (useVariantImage) {
      wrappers.forEach((wrapper) => {
        // Reset to standard mode classes (prevent stale full-width state)
        wrapper.classList.remove('product-info-card-wrapper--full-width');
        wrapper.classList.add('container', 'mobile-full');
        wrapper.setAttribute('data-full-width-mode', 'false');

        const card = wrapper.querySelector('[data-product-info-card]');
        if (card) {
          card.classList.remove('product-info-card--full-width');
        }

        // Handle visibility
        wrapper.classList.toggle('hide', !showInfoCard);
      });
      return;
    }

    // Hide all wrappers if show_info_card is not explicitly true
    if (!showInfoCard) {
      wrappers.forEach((wrapper) => {
        wrapper.classList.add('hide');
      });
      return;
    }

    // Show wrappers and update content
    wrappers.forEach((wrapper) => {
      wrapper.classList.remove('hide');

      const card = wrapper.querySelector('[data-product-info-card]');
      if (!card) return;

      // Update full-width mode classes
      // Always keep container + mobile-full so image respects page width
      wrapper.classList.add('container', 'mobile-full');
      if (fullWidthMode) {
        wrapper.classList.add('product-info-card-wrapper--full-width');
        card.classList.add('product-info-card--full-width');
        wrapper.setAttribute('data-full-width-mode', 'true');
      } else {
        wrapper.classList.remove('product-info-card-wrapper--full-width');
        card.classList.remove('product-info-card--full-width');
        wrapper.setAttribute('data-full-width-mode', 'false');
      }

      // If no content, keep existing DOM
      if (!hasContent) return;

      const content = matchingProduct.info_card[0];
      const desktopImage = content.image && content.image[0] ? content.image[0] : null;
      const mobileImage = content.image_mobile && content.image_mobile[0] ? content.image_mobile[0] : desktopImage;

      if (!desktopImage) return;

      // Build new content using DOM methods (safe escaping)
      card.innerHTML = '';

      // Create picture element
      const picture = document.createElement('picture');

      // Add mobile source if different from desktop
      if (mobileImage && mobileImage.src && mobileImage.src !== desktopImage.src) {
        const source = document.createElement('source');
        source.srcset = mobileImage.src;
        source.media = '(max-width: 900px)';
        picture.appendChild(source);
      }

      // Create img element
      const img = document.createElement('img');
      img.src = desktopImage.src;
      img.alt = (desktopImage.alt || matchingProduct.title || '') + ' info card';
      if (desktopImage.height) img.height = parseInt(desktopImage.height, 10);
      if (desktopImage.width) img.width = parseInt(desktopImage.width, 10);
      img.loading = 'lazy';
      if (fullWidthMode) {
        img.className = 'product-info-card__image--full-width';
      }
      picture.appendChild(img);
      card.appendChild(picture);

      // Add text content only if not in full-width mode
      if (!fullWidthMode) {
        const textDiv = document.createElement('div');
        textDiv.className = 'product-info-card__text';

        const h3 = document.createElement('h3');
        h3.className = 'product-info-card__heading';
        h3.textContent = content.title || '';

        const pSubhead = document.createElement('p');
        pSubhead.className = 'product-info-card__subheading';
        pSubhead.textContent = content.subtitle || '';

        const pInfo = document.createElement('p');
        pInfo.className = 'product-info-card__info';
        // Description is intentional HTML from Accentuate rich text (trusted admin content)
        pInfo.innerHTML = content.description || '';

        textDiv.appendChild(h3);
        textDiv.appendChild(pSubhead);
        textDiv.appendChild(pInfo);
        card.appendChild(textDiv);
      }
    });
  }

  // Preserve the accordion controls and listeners while replacing optional content.
  updateHighlights2Accordion(accordion, matchingProduct) {
    const heading = accordion.querySelector('[data-accordion-heading-text]')
    const wrapper = accordion.querySelector('.accordion__content--wrapper')
    const highlight = matchingProduct.highlights?.[1]
    const content = highlight?.tab_content?.[0]
    const available = matchingProduct.metafields?.highlights_2_available === true && !!content

    accordion.classList.toggle('hide', !available)
    heading.textContent = ''
    wrapper.replaceChildren()
    if (!available) {
      if (accordion.open && typeof accordion.closeContent === 'function') accordion.closeContent()
      return
    }

    const title = Array.isArray(highlight.tab_title) ? highlight.tab_title[0] : highlight.tab_title
    heading.textContent = title || 'Product Highlights'
    const rte = document.createElement('div')
    rte.className = 'rte'
    const panel = document.createElement('div')
    panel.className = 'highlights-content'
    panel.setAttribute('data-highlight-panel-desktop-2', '')
    panel.setAttribute('data-highlight-panel-2', '')
    const text = document.createElement('div')
    text.className = 'highlights-text'
    // Rich text comes from the existing product metafield payload.
    text.innerHTML = content.text || ''
    const imageContainer = document.createElement('div')
    imageContainer.className = 'highlights-image'
    const appendImage = (parent, image) => {
      if (!image?.src) return
      const img = document.createElement('img')
      img.src = image.src
      img.alt = image.alt || ''
      img.loading = 'lazy'
      if (image.height) img.setAttribute('height', image.height)
      if (image.width) img.setAttribute('width', image.width)
      parent.appendChild(img)
    }
    appendImage(imageContainer, content.image?.[0])
    const listContainer = document.createElement('div')
    listContainer.className = 'highlights-list'
    const list = document.createElement('ul')
    for (const item of content.list || []) {
      const li = document.createElement('li')
      appendImage(li, item.image?.[0])
      const text = document.createElement('span')
      text.innerHTML = item.text || ''
      li.appendChild(text)
      list.appendChild(li)
    }
    listContainer.appendChild(list)
    panel.append(text, imageContainer, listContainer)
    rte.appendChild(panel)
    wrapper.appendChild(rte)
    const region = accordion.querySelector('[data-accordion-content]')
    if (accordion.open && region) region.style.maxHeight = `${region.scrollHeight}px`
  }

  // Method to update the product highlights section
  updateProductHighlights(matchingProduct) {
    if (this.productHighlights && matchingProduct) {
      const container = this.productHighlights
      if (!container) return
      
      const managedHighlights2 = (this.product || container).querySelector('[data-highlights-2-accordion]')
      if (managedHighlights2) this.updateHighlights2Accordion(managedHighlights2, matchingProduct)

      matchingProduct.highlights.forEach((highlight, index) => {
        let titleText = highlight.tab_title;

        // Normalize titleText to always be a string
        titleText = Array.isArray(titleText) ? titleText[0] : titleText;
                
        // Increment index here if necessary
        index += 1;
        
        if (titleText) {
          // Check for specific title text and product type
          if (titleText.toLowerCase() === 'dimensions &amp; components' && matchingProduct.type === 'bundle') {
            titleText = 'Bundle Components';
          }   
        }     
      
        // desktop title
        if (container.querySelector(`[data-highlight-title-desktop-${index}]`) != null) {
          let title = container.querySelector(`[data-highlight-title-desktop-${index}]`);
          if (title) {
            title.innerHTML = titleText;
          }
        }
        // mobile title
        if (container.querySelector(`[data-highlight-title-${index}]`) != null) {
          let title = container.querySelector(`[data-highlight-title-${index}]`);
          if (title) {
            title.innerHTML = titleText;
          }
        }
        
        switch (index) {
          case 1:
            if (index === 1) {
              if (container.querySelector(`[data-highlight-panel-desktop-1]`) != null || container.querySelector(`[data-highlight-panel-1]`) != null) {
                // desktop panel 1
                let panel1Desktop = container.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let panelText = panel1Desktop ? panel1Desktop.querySelector('.highlights-text') : null
                let panelImage = panel1Desktop ? panel1Desktop.querySelector('.highlights-image img') : null
                let panelList = panel1Desktop ? panel1Desktop.querySelector('.highlights-list ul') : null
                
                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }
                
                // Update panelImage
                if (panelImage) {
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt)
                  panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                }

                // Update panelList
                if (panelList) {
                  panelList.innerHTML = ''

                  // Add the PFAS callout when the selected product allows it
                  if (window.pfasVisible !== false) {
                    let pfasCallout = `<li class="pfas-pdp-callout">`;
                    if (matchingProduct.pfas_callout.icon) {
                      pfasCallout += matchingProduct.pfas_callout.icon;
                    }
                    if (matchingProduct.pfas_callout.text) {
                      pfasCallout += matchingProduct.pfas_callout.text;
                    }
                    // Only show info icon if tooltip exists
                    if (matchingProduct.pfas_callout.tooltip) {
                      const tooltipId = `pfas-tooltip-${Math.random().toString(36).substr(2, 9)}`;
                      pfasCallout += `
                        <button 
                          class="info-button" 
                          aria-label="More information about PFAS"
                          aria-describedby="${tooltipId}"
                          tabindex="0"
                          type="button"
                        >
                          <span class="info_character_pfas" aria-hidden="true">&#9432;</span>
                          <span id="${tooltipId}" class="tooltip-content" role="tooltip">
                            ${matchingProduct.pfas_callout.tooltip}
                          </span>
                        </button>
                      `;
                    }
                    pfasCallout += `</li>`;
                    panelList.innerHTML = pfasCallout;
                  }

                  // Add the rest of the highlights
                  const highlightList = highlight.tab_content[0].list.map((item) => {
                    return `
                      <li>
                      <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                        ${item.text}
                      </li>
                    `
                  })
                  panelList.innerHTML += highlightList.join('')
                }

                // mobile panel 1
                let panel1 = container.querySelector(`[data-highlight-panel-${index}]`)
                panelText = panel1 ? panel1.querySelector('.highlights-text') : null
                panelImage = panel1 ? panel1.querySelector('.highlights-image img') : null
                panelList = panel1 ? panel1.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelImage
                if (panelImage) {
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt)
                  panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                }

                // Update panelList
                if (panelList) {
                  panelList.innerHTML = '';

                  // Add the PFAS callout when the selected product allows it
                  if (window.pfasVisible !== false) {
                    let pfasCallout = `<li class="pfas-pdp-callout">`;
                    if (matchingProduct.pfas_callout.icon) {
                      pfasCallout += matchingProduct.pfas_callout.icon;
                    }
                    if (matchingProduct.pfas_callout.text) {
                      pfasCallout += matchingProduct.pfas_callout.text;
                    }
                    // Only show info icon if tooltip exists
                    if (matchingProduct.pfas_callout.tooltip) {
                      const tooltipId = `pfas-tooltip-${Math.random().toString(36).substr(2, 9)}`;
                      pfasCallout += `
                        <button 
                          class="info-button" 
                          aria-label="More information about PFAS"
                          aria-describedby="${tooltipId}"
                          tabindex="0"
                          type="button"
                        >
                          <span class="info_character_pfas" aria-hidden="true">&#9432;</span>
                          <span id="${tooltipId}" class="tooltip-content" role="tooltip">
                            ${matchingProduct.pfas_callout.tooltip}
                          </span>
                        </button>
                      `;
                    }
                    pfasCallout += `</li>`;
                    panelList.innerHTML = pfasCallout;
                  }

                  // Add the rest of the highlights
                  const highlightList = highlight.tab_content[0].list.map((item) => {
                    return `
                      <li>
                        <img src="${item.image[0].src}" alt="${item.image[0].alt}" height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                        ${item.text}
                      </li>
                    `;
                  });
                  panelList.innerHTML += highlightList.join('');
                }
              }
            }
          case 2:
            if (managedHighlights2) break
            if (index === 2) {
              if (container.querySelector(`[data-highlight-panel-desktop-2]`) != null || container.querySelector(`[data-highlight-panel-2]`) != null) {
                // desktop panel 2
                let panel2Desktop = container.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let panelText = panel2Desktop ? panel2Desktop.querySelector('.highlights-text') : null
                let panelImage = panel2Desktop ? panel2Desktop.querySelector('.highlights-image img') : null
                let panelList = panel2Desktop ? panel2Desktop.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelImage
                if (panelImage) {
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt)
                  panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                }

                // Update panelList
                let highlightList = highlight.tab_content[0].list.map((item) => {
                  return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                })
                if (panelList) {
                  panelList.innerHTML = ''
                  panelList.innerHTML = highlightList.join('')
                }

                // mobile panel 2
                let panel2 = container.querySelector(`[data-highlight-panel-${index}]`)
                panelText = panel2 ? panel2.querySelector('.highlights-text') : null
                panelImage = panel2 ? panel2.querySelector('.highlights-image img') : null
                panelList = panel2 ? panel2.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text 
                }

                // Update panelImage
                if (panelImage) {
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt)
                  panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                }

                // Update panelList
                if (highlight.tab_content[0].list && Array.isArray(highlight.tab_content[0].list)) {
                  let highlightList = highlight.tab_content[0].list.map((item) => {
                    return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                  })
                  if (panelList) {
                    panelList.innerHTML = ''
                    panelList.innerHTML = highlightList.join('')
                  }
                }
              }
            }
          case 3:
            if (index === 3) {
              // Find the Highlights 3 accordion by heading text or by data attributes
              let highlights3Accordion = null
              
              // First try to find by data-highlight-panel-desktop-3 or data-highlight-panel-3
              const highlights3Panel = document.querySelector('[data-highlight-panel-desktop-3], [data-highlight-panel-3]')
              if (highlights3Panel) {
                highlights3Accordion = highlights3Panel.closest('accordion-element')
              }
              
              // Fallback: search by heading text
              if (!highlights3Accordion) {
                const allAccordions = document.querySelectorAll('accordion-element[data-block-id]')
                for (const accordion of allAccordions) {
                  const heading = accordion.querySelector('.accordion__toggle')
                  if (heading) {
                    const headingText = heading.textContent.trim().toLowerCase()
                    if (headingText.includes('highlights 3') || headingText.includes('highlights3') || headingText.includes('grill')) {
                      highlights3Accordion = accordion
                      break
                    }
                  }
                }
              }
              
              if (highlights3Accordion) {
                // Update the accordion heading with the tab_title
                const accordionHeading = highlights3Accordion.querySelector('.accordion__toggle')
                if (accordionHeading && titleText) {
                  // Preserve the SVG indicator icons
                  const openIndicator = accordionHeading.querySelector('[data-accordion-indicator][data-open]')
                  const closedIndicator = accordionHeading.querySelector('[data-accordion-indicator][data-closed]')
                  
                  // Get just the text content (without the indicators)
                  const textNode = Array.from(accordionHeading.childNodes).find(node => node.nodeType === Node.TEXT_NODE)
                  if (textNode) {
                    textNode.textContent = titleText
                  } else {
                    // If no text node, insert one before the indicators
                    const newTextNode = document.createTextNode(titleText)
                    if (openIndicator) {
                      accordionHeading.insertBefore(newTextNode, openIndicator)
                    } else {
                      accordionHeading.prepend(newTextNode)
                    }
                  }
                }
                
                const contentWrapper = highlights3Accordion.querySelector('.accordion__content--wrapper')
                if (contentWrapper && highlight.tab_content && highlight.tab_content[0]) {
                  // Build the Highlights 3 HTML structure
                  let imageHtml = ''
                  if (highlight.tab_content[0].image && highlight.tab_content[0].image.length > 0 && highlight.tab_content[0].image[0]) {
                    const img = highlight.tab_content[0].image[0]
                    imageHtml = `<img loading="lazy" src="${img.src}" alt="${img.alt || ''}" ${img.height ? `height="${img.height}"` : ''} ${img.width ? `width="${img.width}"` : ''}>`
                  }
                  
                  let listHtml = ''
                  if (highlight.tab_content[0].list && Array.isArray(highlight.tab_content[0].list) && highlight.tab_content[0].list.length > 0) {
                    listHtml = '<ul>'
                    highlight.tab_content[0].list.forEach((item) => {
                      if (item.image && item.image[0]) {
                        listHtml += `<li><img src="${item.image[0].src}" alt="${item.image[0].alt || ''}" height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">${item.text || ''}</li>`
                      }
                    })
                    listHtml += '</ul>'
                  }
                  
                  const textHtml = highlight.tab_content[0].text || ''
                  
                  // Replace the entire wrapper content with the proper structure
                  contentWrapper.innerHTML = `<div class="rte"><div class="highlights-content" data-highlight-panel-desktop-3 data-highlight-panel-3><div class="highlights-text">${textHtml}</div><div class="highlights-image">${imageHtml}</div><div class="highlights-list">${listHtml}</div></div></div>`
                }
              }
              
              // Also update via the standard method if panel exists (for backwards compatibility)
              if (container.querySelector(`[data-highlight-panel-desktop-3]`) != null || container.querySelector(`[data-highlight-panel-3]`) != null) {
                // desktop panel 3
                let panel3Desktop = container.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let highlightsContent = panel3Desktop ? panel3Desktop.querySelector('.highlights-content') : panel3Desktop
                
                let panelText = highlightsContent ? highlightsContent.querySelector('.highlights-text') : null
                let panelImageContainer = highlightsContent ? highlightsContent.querySelector('.highlights-image') : null
                let panelList = highlightsContent ? highlightsContent.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  if (highlight.tab_content && highlight.tab_content[0] && highlight.tab_content[0].text) {
                    panelText.innerHTML = highlight.tab_content[0].text
                  } else {
                    panelText.innerHTML = ''
                  }
                }

                // Update panelImage - create img element if it doesn't exist
                if (panelImageContainer && highlight.tab_content && highlight.tab_content[0] && highlight.tab_content[0].image && highlight.tab_content[0].image.length > 0 && highlight.tab_content[0].image[0]) {
                  let panelImage = panelImageContainer.querySelector('img')
                  if (!panelImage) {
                    panelImage = document.createElement('img')
                    panelImage.setAttribute('loading', 'lazy')
                    panelImageContainer.appendChild(panelImage)
                  }
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt || '')
                  if (highlight.tab_content[0].image[0].height) {
                    panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  }
                  if (highlight.tab_content[0].image[0].width) {
                    panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                  }
                }

                // Update panelList
                if (panelList && highlight.tab_content && highlight.tab_content[0] && highlight.tab_content[0].list && Array.isArray(highlight.tab_content[0].list) && highlight.tab_content[0].list.length > 0) {
                  let highlightList = highlight.tab_content[0].list.map((item) => {
                    return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                  })
                  panelList.innerHTML = highlightList.join('')
                } else if (panelList) {
                  panelList.innerHTML = ''
                }

                // mobile panel 3 (uses same structure as desktop, so the contentWrapper replacement above handles both)
                let panel3 = container.querySelector(`[data-highlight-panel-${index}]`)
                let highlightsContentMobile = panel3 ? panel3.querySelector('.highlights-content') : panel3
                
                panelText = highlightsContentMobile ? highlightsContentMobile.querySelector('.highlights-text') : null
                let panelImageContainerMobile = highlightsContentMobile ? highlightsContentMobile.querySelector('.highlights-image') : null
                panelList = highlightsContentMobile ? highlightsContentMobile.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  if (highlight.tab_content && highlight.tab_content[0] && highlight.tab_content[0].text) {
                    panelText.innerHTML = highlight.tab_content[0].text 
                  } else {
                    panelText.innerHTML = ''
                  }
                }

                // Update panelImage - create img element if it doesn't exist
                if (panelImageContainerMobile && highlight.tab_content && highlight.tab_content[0] && highlight.tab_content[0].image && highlight.tab_content[0].image.length > 0 && highlight.tab_content[0].image[0]) {
                  let panelImage = panelImageContainerMobile.querySelector('img')
                  if (!panelImage) {
                    panelImage = document.createElement('img')
                    panelImage.setAttribute('loading', 'lazy')
                    panelImageContainerMobile.appendChild(panelImage)
                  }
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt || '')
                  if (highlight.tab_content[0].image[0].height) {
                    panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  }
                  if (highlight.tab_content[0].image[0].width) {
                    panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                  }
                }

                // Update panelList
                if (panelList && highlight.tab_content && highlight.tab_content[0] && highlight.tab_content[0].list && Array.isArray(highlight.tab_content[0].list) && highlight.tab_content[0].list.length > 0) {
                  let highlightList = highlight.tab_content[0].list.map((item) => {
                    return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                  })
                  panelList.innerHTML = highlightList.join('')
                } else if (panelList) {
                  panelList.innerHTML = ''
                }
              }
            }
          case 4:
            if (index === 4) {
              if (container.querySelector(`[data-highlight-panel-desktop-4]`) != null || container.querySelector(`[data-highlight-panel-4]`) != null) {
                // desktop panel 4 (dimensions) - only use panel 4, not 3 (since Highlights 3 now uses panel 3)
                let panel4desktop = container.querySelector(`[data-highlight-panel-desktop-4]`)

                // mobile panel 4 (dimensions) - only use panel 4, not 3 (since Highlights 3 now uses panel 3)
                let panel4 = container.querySelector(`[data-highlight-panel-4]`)

                if (matchingProduct.type == 'bundle') {
                  document.addEventListener('linked-product:updated', function(){
                    const bundleJSON = JSON.parse(document.querySelector("#bundle-json")?.innerHTML)
                    const bundleProducts = bundleJSON.products
                    const bundleItemsWrapper = document.querySelector('[data-bundle-items-container]')
                    let bundleItemsMobileWrapper = document.querySelector('[data-bundle-items-mobile-container]')
                    let bundleContainer = null
                    if (bundleItemsWrapper) {
                      bundleContainer = bundleItemsWrapper.querySelector('[data-bundle-items]')
                    }
                    let bundleContainerMobile = null
                    if (bundleItemsMobileWrapper) {
                      bundleContainerMobile = bundleItemsMobileWrapper?.querySelector('[data-bundle-items-mobile]')
                    } else {
                      bundleItemsMobileWrapper = document.createElement('div')
                      bundleItemsMobileWrapper.classList.add('bundle-items-container')
                      bundleItemsMobileWrapper.setAttribute('data-bundle-items-mobile-container', '')
                      bundleItemsMobileWrapper.innerHTML = `
                        <h5 aria-level="4" role="heading">This bundle includes:</h5>
                        <div class="bundle-items-mobile" data-bundle-items-mobile=""></div>
                      `
                      panel4.innerHTML = ''
                      panel4.append(bundleItemsMobileWrapper)
                      bundleContainerMobile = bundleItemsMobileWrapper?.querySelector('[data-bundle-items-mobile]')
                    } 

                    if (bundleContainer) {
                      bundleContainer.innerHTML = '';
                    }
                    
                    if (bundleContainerMobile) {
                        bundleContainerMobile.innerHTML = '';
                    }

                    for (let i = 0; i < bundleProducts.length; i++) {
                      let product = bundleProducts[i]
                      let item = document.createElement('div')
                      item.classList.add('bundle-item')
                      let productTitle = product.product_title
                      let variantTitle = product.variant_title
                      let featuredImage = product.product_images[0].src
                      let variantImage = product.variant_featured_image
                      let url = product.url
                      if (variantTitle.toLowerCase() !== 'default title') {
                        item.innerHTML = `
                          <div class='bundle-item-inner'>
                            <a href='${url}'>
                            <div class='bundle-item-img-container'>
                              <img class='bundle-item-img' src='${variantImage}' alt='${productTitle}'></div>
                              <h6 class='bundle-item-title'>${productTitle}</h6>
                            </a>
                          </div>
                        `
                      } else {
                        item.innerHTML = `
                          <div class='bundle-item-inner'>
                            <a href='${url}'>
                            <div class='bundle-item-img-container'>
                              <img class='bundle-item-img' src='${featuredImage}' alt='${productTitle}'></div>
                              <h6 class='bundle-item-title'>${productTitle}</h6>
                            </a>
                          </div>
                        `
                      }
                
                      bundleContainer?.appendChild(item)
                      let itemClone = item.cloneNode(true)
                      bundleContainerMobile?.appendChild(itemClone)
                    }
                  })
                } else {
                  if (highlight.tab_content) {
                    let tabContent = highlight.tab_content.map((item) => {
                      return `
                      <div class="dimensions-item">
                        <img src="${item.image[0].src}" loading="lazy" alt="${item.image[0].alt}" height="${item.image[0].height}" width="${item.image[0].width}"> 
                        <div class="dimensions-text">
                          ${item.text}
                        </div>
                      </div>
                    `
                    })
                    if (panel4desktop) {
                      panel4desktop.innerHTML = ''
                      panel4desktop.innerHTML = tabContent.join('')
                    }
                    if (panel4) {
                      panel4.innerHTML = ''
                      panel4.innerHTML = tabContent.join('')
                    }
                  }
                }
              }
            }
          case 4:
            if (index === 4) {
              if (container.querySelector(`[data-highlight-panel-desktop-4]`) != null || container.querySelector(`[data-highlight-panel-4]`) != null) {
                // desktop panel 4
                let panel4Desktop = container.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let panelText = panel4Desktop ? panel4Desktop.querySelector('.highlights-text') : null
                let panelHeader = panel4Desktop ? panel4Desktop.querySelector('.highlights-list h3') : null
                let panelList = panel4Desktop ? panel4Desktop.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelHeader
                if (panelHeader) {
                  panelHeader.innerText = highlight.tab_content[0].heading
                }

                // Update panelList
                if (highlight.tab_content[0].list && Array.isArray(highlight.tab_content[0].list)) {
                  let highlightList = highlight.tab_content[0].list.map((item) => {
                    return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                  })
                  if (panelList) {
                    panelList.innerHTML = ''
                    panelList.innerHTML = highlightList.join('')
                  }
                }

                // mobile panel 4
                let panel4 = container.querySelector(`[data-highlight-panel-${index}]`)
                panelText = panel4 ? panel4.querySelector('.highlights-text') : null
                panelHeader = panel4 ? panel4.querySelector('.highlights-list h3') : null
                panelList = panel4 ? panel4.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelHeader
                if (panelHeader) {
                  panelHeader.innerText = highlight.tab_content[0].heading
                }

                // Update panelList
                if (highlight.tab_content[0].list && Array.isArray(highlight.tab_content[0].list)) {
                  let highlightList = highlight.tab_content[0].list.map((item) => {
                    return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                  })
                  if (panelList) {
                    panelList.innerHTML = ''
                    panelList.innerHTML = highlightList.join('')
                  }
                }
              }
            }
            case 5:
              if (index === 5) {
                const curr_highlight = matchingProduct.highlights[index]
                // the selectors in here have been changed from the container context as this has moved outside of the normal highlight panel on the 2.0 upgrade
                if (document.querySelector(`[data-highlight-panel-desktop-5]`) != null || document.querySelector(`[data-highlight-panel-5]`) != null) {
                  // desktop panel 5
                  let panel5Desktop = document.querySelector(`[data-highlight-panel-desktop-${index}]`)
                  if (panel5Desktop) {
                    panel5Desktop.innerHTML = curr_highlight.tab_content
                  }
                  
                  // mobile panel 5
                  let panel5 = document.querySelector(`[data-highlight-panel-${index}]`)
                  if (panel5) {
                    panel5.innerHTML = curr_highlight.tab_content
                  }
                }
              }
            case 6:
            if (index === 6) {
              // the selectors in here have been changed from the container context as this has moved outside of the normal highlight panel on the 2.0 upgrade
              if (document.querySelector(`[data-highlight-panel-desktop-6]`) != null || document.querySelector(`[data-highlight-panel-6]`) != null) {
                // desktop panel 5
                let panel6Desktop = document.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let highlightTabContent = highlight.tab_content.replaceAll('--', '<span class="circle filled"></span>').replaceAll('()', '<span class="circle empty"></span>')
                if (panel6Desktop) {
                  panel6Desktop.innerHTML = highlightTabContent
                }
                
                // mobile panel 5
                let panel6 = document.querySelector(`[data-highlight-panel-${index}]`)
                if (panel6) {
                  panel6.innerHTML = highlightTabContent
                }
              }
            }
        }
      })

      // Handle accordion visibility for Highlights 2 and 3 based on metafields
      // Check if Highlights 2 is enabled via metafield
      const hasHighlights2 = matchingProduct.metafields && 
                            matchingProduct.metafields.show_product_highlights_2 && 
                            (matchingProduct.metafields.show_product_highlights_2 === 'true' || matchingProduct.metafields.show_product_highlights_2 === true)
      
      // Check if Highlights 3 is enabled via metafield
      const hasHighlights3 = matchingProduct.metafields && 
                            matchingProduct.metafields.show_product_highlights_3 && 
                            (matchingProduct.metafields.show_product_highlights_3 === 'true' || matchingProduct.metafields.show_product_highlights_3 === true)
      
      // Find Highlights 2 accordion by looking for the panel with data-highlight-panel-desktop-2 or data-highlight-panel-2
      let highlights2Accordion = null
      const highlights2Panel = document.querySelector('[data-highlight-panel-desktop-2], [data-highlight-panel-2]')
      if (highlights2Panel) {
        highlights2Accordion = highlights2Panel.closest('accordion-element')
      }
      // Fallback: search by heading text if panel not found (search in product container first, then document)
      if (!highlights2Accordion) {
        const searchContainers = this.product ? [this.product, document] : [document]
        for (const searchContainer of searchContainers) {
          const allAccordions = searchContainer.querySelectorAll('accordion-element[data-block-id]')
          for (const accordion of allAccordions) {
            const heading = accordion.querySelector('.accordion__toggle')
            if (heading) {
              const headingText = heading.textContent.trim().toLowerCase()
              if (headingText.includes('highlights 2') || headingText.includes('highlights2')) {
                highlights2Accordion = accordion
                break
              }
            }
          }
          if (highlights2Accordion) break
        }
      }
      if (highlights2Accordion && !managedHighlights2) {
        if (hasHighlights2) {
          highlights2Accordion.classList.remove('hide')
        } else {
          highlights2Accordion.classList.add('hide')
        }
      }
      
      // Find Highlights 3 accordion by looking for the panel with data-highlight-panel-desktop-3 or data-highlight-panel-3
      let highlights3Accordion = null
      const highlights3Panel = document.querySelector('[data-highlight-panel-desktop-3], [data-highlight-panel-3]')
      if (highlights3Panel) {
        highlights3Accordion = highlights3Panel.closest('accordion-element')
      }
      // Fallback: search by heading text if panel not found (search in product container first, then document)
      if (!highlights3Accordion) {
        const searchContainers = this.product ? [this.product, document] : [document]
        for (const searchContainer of searchContainers) {
          const allAccordions = searchContainer.querySelectorAll('accordion-element[data-block-id]')
          for (const accordion of allAccordions) {
            const heading = accordion.querySelector('.accordion__toggle')
            if (heading) {
              const headingText = heading.textContent.trim().toLowerCase()
              if (headingText.includes('highlights 3') || headingText.includes('highlights3')) {
                highlights3Accordion = accordion
                break
              }
            }
          }
          if (highlights3Accordion) break
        }
      }
      if (highlights3Accordion) {
        if (hasHighlights3) {
          highlights3Accordion.classList.remove('hide')
        } else {
          highlights3Accordion.classList.add('hide')
        }
      }
    }
  }

  // Method to update the what's included section based on the linked product
  // GP-869 A/B test: only reveal when Intelligems has bucketed this visitor into the test (see 'whats-included-test-active' on <body>); remove this gating once the test wins/completes
  updateWhatsIncluded(matchingProduct) {
    if (this.whatsIncluded && matchingProduct) {
      const included = matchingProduct.metafields.whats_included
      const isTestActive = document.body.classList.contains('whats-included-test-active')

      if (isTestActive && Array.isArray(included) && included.length) {
        this.whatsIncluded.innerHTML = included.join(' + ')
        this.whatsIncluded.classList.remove('hide')
      } else {
        this.whatsIncluded.innerHTML = ''
        this.whatsIncluded.classList.add('hide')
      }
    }
  }

  //Method to update the product features section based on color selected
  updateProductFeatures(matchingProduct) {
    if (this.productFeatures && matchingProduct) {
      const featuresContainer = $('product-features .slide-track')
      if (!featuresContainer) return

      let features = matchingProduct.features.map((feature, index) => {
        if (feature.image[0].src != "" || feature.description != "" || feature.title != "") {
          return `
          <div class="item" data-originalitemindex="${index}">
            <div class="feature-wrap animation">
              <div class="feature-image animation">
              <img
              class=""
              sizes="auto"
              src="${feature.image[0].src}"
              srcset="${feature.image[0].src}"
              height=""
              width=""
            >
              </div>
              <div class="info animation">
                <div class="feature-title" style="min-height: 28px;">${feature.title}</div>
                <div class="feature-description">${feature.description}</div>
              </div>
            </div>
          </div>
          `
        }
      })

      let slickOptions = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        centerPadding: '230px',
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnFocus: true,
        pauseOnHover: true,
        appendArrows: "product-features .desktop-arrow-container",
        arrows: true,
        prevArrow: '<button type="button" class="prev-button" aria-label="Previous product feature"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 48.5693C37.7025 48.5693 48 38.2719 48 25.5693C48 12.8668 37.7025 2.56934 25 2.56934C12.2975 2.56934 2 12.8668 2 25.5693C2 38.2719 12.2975 48.5693 25 48.5693ZM25 50.5693C38.8071 50.5693 50 39.3765 50 25.5693C50 11.7622 38.8071 0.569336 25 0.569336C11.1929 0.569336 0 11.7622 0 25.5693C0 39.3765 11.1929 50.5693 25 50.5693Z" fill="#19341A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.4887 17.9985L37.8526 24.3624C38.2431 24.7529 38.2431 25.3861 37.8526 25.7766L31.4887 32.1406C31.0981 32.5311 30.465 32.5311 30.0744 32.1406C29.6839 31.7501 29.6839 31.1169 30.0744 30.7264L34.7313 26.0695H12.8555V24.0695H34.7313L30.0744 19.4127C29.6839 19.0221 29.6839 18.389 30.0744 17.9985C30.465 17.6079 31.0981 17.6079 31.4887 17.9985Z" fill="#19341A"/></svg></button>',
        nextArrow: '<button type="button" class="next-button" aria-label="Next product feature"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 48.5693C37.7025 48.5693 48 38.2719 48 25.5693C48 12.8668 37.7025 2.56934 25 2.56934C12.2975 2.56934 2 12.8668 2 25.5693C2 38.2719 12.2975 48.5693 25 48.5693ZM25 50.5693C38.8071 50.5693 50 39.3765 50 25.5693C50 11.7622 38.8071 0.569336 25 0.569336C11.1929 0.569336 0 11.7622 0 25.5693C0 39.3765 11.1929 50.5693 25 50.5693Z" fill="#19341A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.4887 17.9985L37.8526 24.3624C38.2431 24.7529 38.2431 25.3861 37.8526 25.7766L31.4887 32.1406C31.0981 32.5311 30.465 32.5311 30.0744 32.1406C29.6839 31.7501 29.6839 31.1169 30.0744 30.7264L34.7313 26.0695H12.8555V24.0695H34.7313L30.0744 19.4127C29.6839 19.0221 29.6839 18.389 30.0744 17.9985C30.465 17.6079 31.0981 17.6079 31.4887 17.9985Z" fill="#19341A"/></svg></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              centerMode: true,
              centerPadding: '150px',
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              centerPadding: '60px',
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      }

      $('product-features .slide-track.slick-initialized').slick('destroy');
      featuresContainer.html('')
      featuresContainer.html (features.join(''))
      $('product-features .slide-track:not("slick-initialized")').slick(slickOptions);
      $('product-features .slide-track').slick('slickGoTo', 0);
      $('product-features [data-feature-play-button]')
        .attr('data-paused', 'false')
        .attr('aria-label', "Pause Why You'll Love It carousel");
    }
  }

  // Method to update the product collection video
  updateProductCollectionVideo(matchingProduct) {
    if (!this.productCollectionVideo || !matchingProduct) return

    const videoContainer = this.productCollectionVideo.querySelector('.pdp-video-wrap')
    if (!videoContainer) return

    // Check if matchingProduct.video exists and has at least one entry
    if (!matchingProduct.video || matchingProduct.video.length === 0) return

    const videoUrl = matchingProduct.video[0].src
    const isExternalVideo = videoUrl.includes('youtube') || videoUrl.includes('vimeo')
    const videoPoster = this.productCollectionVideo.querySelector('[data-video-poster]')

    // Common logic for show-poster class
    if (videoPoster) {
      videoContainer.classList.add('show-poster')
    } else {
      videoContainer.classList.remove('show-poster')
    }

    // Function to initialize play button functionality for non-external videos
    function initPlayButton() {
      const triggerButton = videoContainer.querySelector('.trigger-btn')
      if (triggerButton) {
        triggerButton.addEventListener('click', function () {
          const videoPosterElement = videoContainer.querySelector('.video-poster')
          const videoElement = videoContainer.querySelector('[data-video]')


          if (videoPosterElement) {
            videoPosterElement.style.display = 'none'
          }

          if (videoElement) {
            videoElement.style.visibility = 'visible'
            videoElement.controls = true
            videoElement.play()
          }
        })
      }
    }

    if (isExternalVideo) {
      videoContainer.classList.add('video-external')
      videoContainer.classList.remove('video-inline')
      // Fetch poster URL from matchingProduct
      const posterUrl = matchingProduct.video[0].image
      //if poster present

      if (posterUrl) {
        videoContainer.classList.add('show-poster')

        videoContainer.innerHTML = `
          <div id="pdp-video-player"></div>
          <div class="video-poster" style="background-color: rgb(255, 255, 255); background-image: url('${posterUrl}');" data-bgset="${posterUrl}" data-video-poster>
            <button type="button" class="trigger-btn" aria-label="Play video">
                <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-trigger" viewBox="0 0 32 32">
                  <path fill="#000000" d="M12.8,8.8l9.6,7.2l-9.6,7.2V8.8z M32,16c0,2.9-0.7,5.6-2.2,8.1c-1.4,2.4-3.3,4.3-5.7,5.7C21.6,31.3,18.9,32,16,32s-5.6-0.7-8.1-2.2c-2.4-1.4-4.3-3.3-5.7-5.7C0.7,21.6,0,18.9,0,16c0-2.9,0.7-5.6,2.2-8.1c1.4-2.4,3.3-4.3,5.7-5.7C10.4,0.7,13.1,0,16,0c2.9,0,5.6,0.7,8.1,2.2c2.4,1.4,4.3,3.3,5.7,5.7C31.3,10.4,32,13.1,32,16z M28.8,16c0-2.3-0.6-4.5-1.8-6.5c-1.1-1.9-2.7-3.5-4.6-4.6c-2-1.2-4.2-1.8-6.5-1.8s-4.5,0.6-6.5,1.8C7.6,6.1,6.1,7.6,4.9,9.5c-1.2,2-1.8,4.2-1.8,6.5s0.6,4.5,1.8,6.5c1.1,1.9,2.7,3.5,4.6,4.6c2,1.2,4.2,1.8,6.5,1.8s4.5-0.6,6.5-1.8c1.9-1.1,3.5-2.7,4.6-4.6C28.3,20.5,28.8,18.3,28.8,16z"></path>
                </svg>
            </button>
          </div>
          `

        let player
        Simplistic.YoutubePlayer.loadVideo(function () {
          player = new YT.Player('pdp-video-player', {
            playerVars: {
              allowfullscreen: 1,
              frameborder: 0,
              controls: Simplistic.getQueryParam('controls', `${matchingProduct.video[0].src}`) || 1,
              autohide: 1,
              rel: Simplistic.getQueryParam('rel', `${matchingProduct.video[0].src}`) || 0
            },
            videoId: Simplistic.YoutubePlayer.extractVideoID(`${matchingProduct.video[0].src}`),
            events: {
              onReady: onPlayerReady
            }
          })
        })

        function onPlayerReady(event) {
          $('.pdp-video .trigger-btn').click(function () {
            $('.pdp-video .video-poster').hide()
            $('.pdp-video #pdp-video-player').css('visibility', 'visible')
            player.playVideo()
          })
        }
      }
      //if no poster present
      else {
        videoContainer.innerHTML = `
            <iframe
                class="pdp-video-element"
                src="${videoUrl}"
                frameborder="0"
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
        `
      }
    } else {
      videoContainer.classList.remove('video-external')
      videoContainer.classList.add('video-inline')

      // Fetch poster URL from matchingProduct
      const posterUrl = matchingProduct.video[0].image

      // Create videoPoster div
      const videoPosterDiv = `
        <div class="video-poster" style="background-color: rgb(255, 255, 255); background-image: url('${posterUrl}');" data-bgset="${posterUrl}" data-video-poster>
            <button type="button" class="trigger-btn" aria-label="Play video">
                <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-trigger" viewBox="0 0 32 32">
                  <path fill="#000000" d="M12.8,8.8l9.6,7.2l-9.6,7.2V8.8z M32,16c0,2.9-0.7,5.6-2.2,8.1c-1.4,2.4-3.3,4.3-5.7,5.7C21.6,31.3,18.9,32,16,32s-5.6-0.7-8.1-2.2c-2.4-1.4-4.3-3.3-5.7-5.7C0.7,21.6,0,18.9,0,16c0-2.9,0.7-5.6,2.2-8.1c1.4-2.4,3.3-4.3,5.7-5.7C10.4,0.7,13.1,0,16,0c2.9,0,5.6,0.7,8.1,2.2c2.4,1.4,4.3,3.3,5.7,5.7C31.3,10.4,32,13.1,32,16z M28.8,16c0-2.3-0.6-4.5-1.8-6.5c-1.1-1.9-2.7-3.5-4.6-4.6c-2-1.2-4.2-1.8-6.5-1.8s-4.5,0.6-6.5,1.8C7.6,6.1,6.1,7.6,4.9,9.5c-1.2,2-1.8,4.2-1.8,6.5s0.6,4.5,1.8,6.5c1.1,1.9,2.7,3.5,4.6,4.6c2,1.2,4.2,1.8,6.5,1.8s4.5-0.6,6.5-1.8c1.9-1.1,3.5-2.7,4.6-4.6C28.3,20.5,28.8,18.3,28.8,16z"></path>
                </svg>
            </button>
        </div>
      `

      // Clear the videoContainer and reset for non-external video
      videoContainer.innerHTML = videoPosterDiv + `<video data-video class="pdp-video-element" controls poster="${posterUrl}"></video>`

      const videoElement = videoContainer.querySelector('[data-video]')
      const videoSrcElement = document.createElement('source')
      videoSrcElement.setAttribute('data-video-src', '')
      videoSrcElement.setAttribute('src', videoUrl)
      if (videoElement) {
        videoElement.appendChild(videoSrcElement)
        videoElement.load()
      }

      // Call the play button initialization function
      initPlayButton()
    }
  }

  // Method to updated the "recently added" flair
  updateRecentlyAddedCount(matchingProduct) {
    if(matchingProduct.recently_added_count && this.productRecentlyAddedCount) {
      this.productRecentlyAddedCount.textContent = matchingProduct.recently_added_count
    }
    if (this.productRecentlyAddedContainer) {
      this.productRecentlyAddedContainer.classList.toggle('hide', Number(matchingProduct.recently_added_count) <= 0)
    }
  }

  updateProductCallouts(matchingProduct) {
    if (!matchingProduct) return;

    // Helper function to handle special conditions for callout texts
    const handleSpecialConditions = (element, text, color) => {
      if (!element || !text) return;

      if (text.toLowerCase().includes('limited time only') || text.toLowerCase().includes('limited time offer') || text.toLowerCase().includes('limited quantities') || text.toLowerCase().includes('quantities are limited')) {
        element.style.color = '#ab252b';
      } else if (text.toLowerCase().includes('free shipping')) {
        element.style.color = '#19341a';
      } else {
        element.style.color = color;
      }
    };

    // Helper function to calculate discount percentage
    const calculateDiscountPercentage = (compareAtPrice, regularPrice) => {
      if (compareAtPrice > regularPrice) {
        compareAtPrice = parseFloat(compareAtPrice).toFixed(2);
        regularPrice = parseFloat(regularPrice).toFixed(2);
        
        const discountDifference = compareAtPrice - regularPrice;
        const percentage = (discountDifference / compareAtPrice) * 100;
        return Math.floor(percentage);
      }
      return 0;
    };

    // Function to update callout text and color
    const updateCallout = (container, text, color, calloutNumber = null) => {
      if (!container) return;

      // If no text, remove the inner element to match Liquid template behavior
      if (!text || text.trim() === '') {
        const existingElement = container.firstElementChild;
        if (existingElement) {
          existingElement.remove();
        }
        return null;
      }

      // Create or get the child element
      let element = container.firstElementChild;
      
      // For callout two and three, ensure we use span and correct structure
      if (calloutNumber === 'two' || calloutNumber === 'three') {
        // If element doesn't exist or is wrong type, create/update it
        if (!element || element.tagName !== 'SPAN') {
          if (element) {
            element.remove();
          }
          element = document.createElement('span');
          container.appendChild(element);
        }
        // Ensure classes are correct
        element.classList.add('product-callout');
        if (calloutNumber === 'two') {
          element.classList.add('product-callout--two');
        } else if (calloutNumber === 'three') {
          element.classList.add('product-callout--three');
        }
        // Add or remove free-shipping class
        if (text.toLowerCase().includes('free shipping')) {
          element.classList.add('free-shipping');
        } else {
          element.classList.remove('free-shipping');
        }
      } else {
        // For other callouts (callout one), use p tag
        if (!element) {
          element = document.createElement('p');
          container.appendChild(element);
        }
        element.classList.add('product-callout');
      }

      // Update text content and color
      element.textContent = text;
      element.style.color = color || '';

      return element;
    };

    // Update calloutTextOne
    if (this.calloutTextOne) {
      this.calloutTextOne.forEach(callout => {
        let elementOne = updateCallout(callout, matchingProduct.calloutTextOne, matchingProduct.calloutColorOne);
        handleSpecialConditions(elementOne, matchingProduct.calloutTextOne, matchingProduct.calloutColorOne);
      })
    }

    // Update calloutTextTwo
    if (this.calloutTextTwo) {
      this.calloutTextTwo.forEach(callout => {
        let elementTwo = updateCallout(callout, matchingProduct.calloutTextTwo, matchingProduct.calloutColorTwo, 'two');
        handleSpecialConditions(elementTwo, matchingProduct.calloutTextTwo, matchingProduct.calloutColorTwo);
      })
    }

    // Update calloutTextThree
    if (this.calloutTextThree) {
      let calloutText = matchingProduct.calloutTextThree || '';
      let calloutColor = matchingProduct.calloutColorThree || '';

      // If calloutText is not provided, proceed with the logic to determine it
      if (!calloutText) {
        const variant = matchingProduct.variants ? matchingProduct.variants[0] : null;

        if (variant) {
          const regularPriceLabel = matchingProduct.regularPriceLabel ? matchingProduct.regularPriceLabel.toLowerCase() : '';

          let regularPrice = variant.price;
          if (typeof regularPrice === 'string') {
            regularPrice = parseFloat(regularPrice.replace(/[^0-9.-]+/g, ''));
          }
      
          let compareAtPrice = variant.compare_at_price;
          if (compareAtPrice && typeof compareAtPrice === 'string') {
            compareAtPrice = parseFloat(compareAtPrice.replace(/[^0-9.-]+/g, ''));
          }

          if ((regularPriceLabel === 'clearance' || regularPriceLabel === 'sale') && compareAtPrice > regularPrice) {
            const discountPercentage = calculateDiscountPercentage(compareAtPrice, regularPrice);
            calloutText = `${discountPercentage}% Off`;
            calloutColor = '#ab252b';
          }
        }
      }

      // Handle special conditions for callout three if text exists
      if (calloutText && (calloutText.toLowerCase().includes('limited quantities') || calloutText.toLowerCase().includes('quantities are limited'))) {
        calloutColor = '#ab252b';
      }

      this.calloutTextThree.forEach(callout => {
        let elementThree = updateCallout(callout, calloutText, calloutColor, 'three');
        handleSpecialConditions(elementThree, calloutText, calloutColor);
      })
    }
  }  

  updateAboveTitleText(matchingProduct) {
    if (!this.aboveTitleText) return

    this.aboveTitleText.innerHTML = matchingProduct?.aboveTitleText || ''
  }  
    
  // Method to update the state of the ATC button based on selected color
  updateATCState(selectedOption) {
    // Check if the selected option is OOS
    if (selectedOption?.classList.contains('soldout')) {
      // If disabled, hide the product available element
      this.productAvailableElement?.classList.add('hide')
      this.productStockMessage?.classList.add('hide')

      // Show the product soldout element
      this.productSoldOutElement?.classList.remove('hide')
    } else {
      // If not disabled, enable the product available element
      this.productAvailableElement?.classList.remove('hide')
      this.productStockMessage?.classList.remove('hide')

      // Hide the product soldout element
      this.productSoldOutElement?.classList.add('hide')
    }
  }

  // method to update the bundle json object used for the bundle functionality 
  async updateBundleJSON(matchingProduct) {  
    // Get the bundle-json element
    let bundleJsonElement = document.getElementById('bundle-json');
  
      const productHandle = matchingProduct.handle;
  
      if (productHandle) {
        try {
          const responseText = await this.fetchProduct(productHandle);
          const bundleJSON = responseText['bundle-json'];
  
          if (bundleJSON) {
            // Parse bundleJSON as a DOM element
            const parsedBundleJSON = new DOMParser().parseFromString(bundleJSON, 'text/html');
  
            // Extract the contents of the #bundle-json element
            const targetContent = parsedBundleJSON.querySelector('#bundle-json').textContent;
            
            if (!bundleJsonElement){
              const bundle_button = document.querySelector('[data-add-button-container]')
              const element = document.createElement('div')
              element.style.display = "none"
              element.id = "bundle-json"
              bundle_button.append(element)
              bundleJsonElement = element
            }
            // Update the innerHTML of the target element
            bundleJsonElement.innerHTML = targetContent;
          }
        } catch (error) {
          console.error('Error updating bundle JSON:', error);
        }
      }
  }  

  // helper function to fetch the bundle json section using section rendering API
  async fetchProduct(handle) {
    const url = new URL(`/products/${handle}`, window.location.origin);
    url.searchParams.set('sections', 'bundle-json');

    return fetch(url)
      .then((response) => response.json())
      .then((responseText) => {
        return responseText
      })
      .catch(console.error);
  }

  updateInStockMessage(matchingProduct) {
    let stockMessage = matchingProduct.stockMessage

    if (matchingProduct.freeShipping) {
      stockMessage = matchingProduct.freeShipping
    }

    if (!this.inStockMessageElement) return

    const icon = this.inStockMessageElement.querySelector('span:first-child')
    this.inStockMessageElement.replaceChildren()

    if (icon) {
      this.inStockMessageElement.appendChild(icon)
    }

    if (stockMessage) {
      this.inStockMessageElement.insertAdjacentHTML('beforeend', this.getStockMessageText(stockMessage));
      this.inStockMessageElement.classList.remove('hide')
    } else {
      this.inStockMessageElement.classList.add('hide')
    }
  }  

  getStockMessageText(stockMessage) {
    const messageFragment = document.createElement('template')
    messageFragment.innerHTML = stockMessage

    const firstElement = messageFragment.content.firstElementChild
    if (!firstElement) return stockMessage

    if (firstElement.tagName.toLowerCase() === 'svg') {
      firstElement.remove()
    } else if (
      firstElement.tagName.toLowerCase() === 'span' &&
      firstElement.children.length === 1 &&
      firstElement.firstElementChild.tagName.toLowerCase() === 'svg' &&
      firstElement.textContent.trim() === ''
    ) {
      firstElement.remove()
    }

    return messageFragment.innerHTML
  }

  updateProductOverlayBadge(matchingProduct) {
    // Query fresh each time to ensure we have the correct DOM elements
    const overlayBadge = document.querySelector('.product-gallery__overlay-badge');
    const overlayBadgeText = document.querySelector('.product-gallery__overlay-badge-text');
    
    if (!overlayBadge || !overlayBadgeText || !matchingProduct) return;

    const badgeData = matchingProduct.overlay_badge;
    
    if (badgeData && badgeData.show) {
      overlayBadge.style.display = 'block';
      // Only update color if a valid color is provided
      if (badgeData.color) {
        overlayBadge.style.background = badgeData.color;
      }
      if (badgeData.text) {
        overlayBadgeText.textContent = badgeData.text;
      }
    } else {
      overlayBadge.style.display = 'none';
    }
  }

  updateFreeGiftWrappers(matchingProduct) {
    if (!matchingProduct) return;

    // Query fresh each time to ensure we have the latest DOM elements
    // Use document to ensure we find elements even if they're outside the product container
    const freeGiftWrappers = document.querySelectorAll('[data-free-gift-wrapper]');
    if (!freeGiftWrappers || freeGiftWrappers.length === 0) return;

    // Get the product price from the variant data
    // Note: Shopify variant.price is in cents, but may be provided as string or number
    const variant = matchingProduct.variants ? matchingProduct.variants[0] : null;
    
    let productPrice = 0;
    
    // Try to get price from variant first
    if (variant && variant.price !== undefined && variant.price !== null) {
      if (typeof variant.price === 'string') {
        const parsed = parseFloat(variant.price.replace(/[^0-9.-]+/g, '')) || 0;
        // If the parsed value is less than 1000, it's likely in dollars, convert to cents
        // Otherwise assume it's already in cents
        productPrice = parsed < 1000 ? Math.round(parsed * 100) : parsed;
      } else if (typeof variant.price === 'number') {
        // If the number is less than 1000, it's likely in dollars, convert to cents
        // Otherwise assume it's already in cents
        productPrice = variant.price < 1000 ? Math.round(variant.price * 100) : variant.price;
      }
    }
    
    // Fallback: Try to get price from the displayed price element
    if ((!productPrice || productPrice <= 0) && this.productPrice) {
      const priceText = this.productPrice.textContent || '';
      // Extract numeric value from price text (handles formats like "$275.00" or "Our Price $275")
      const priceMatch = priceText.match(/[\d,]+\.?\d*/);
      if (priceMatch) {
        // Remove commas and convert to cents
        const dollars = parseFloat(priceMatch[0].replace(/,/g, ''));
        if (!isNaN(dollars) && dollars > 0) {
          productPrice = Math.round(dollars * 100); // Convert dollars to cents
        }
      }
    }
    
    // Ensure productPrice is a valid number
    if (!productPrice || isNaN(productPrice) || productPrice <= 0) return;

    // Convert to number explicitly (ensure it's in cents)
    productPrice = Number(productPrice);
    
    const isPreOrderActiveOnSite = window.themeSettings?.isPreOrderActiveOnSite === true;
    const isPreorderProduct = isPreOrderActiveOnSite && matchingProduct.metafields?.preorder;

    freeGiftWrappers.forEach(wrapper => {
      const tier = wrapper.getAttribute('data-free-gift-tier');
      const isTier2 = tier === '2';
      
      // Check if should be hidden due to preorder tag
      // Only check the current matchingProduct tags, not the initial Liquid state
      if (isPreorderProduct) {
        wrapper.classList.add('hide');
        return;
      }

      let shouldShow = false;

      if (isTier2) {
        // Tier 2: Show if price >= free_gift_price_tier2
        const tier2Threshold = parseInt(wrapper.getAttribute('data-free-gift-price-tier2')) || 0;
        shouldShow = productPrice >= tier2Threshold;
      } else {
        // Tier 1: Show if price >= free_gift_price AND price < free_gift_price_tier2
        const tier1Threshold = parseInt(wrapper.getAttribute('data-free-gift-price')) || 0;
        const tier2ThresholdAttr = wrapper.getAttribute('data-free-gift-price-tier2');
        const tier2Threshold = tier2ThresholdAttr ? parseInt(tier2ThresholdAttr) : Infinity;
        shouldShow = productPrice >= tier1Threshold && productPrice < tier2Threshold;
      }

      // Explicitly add or remove the hide class
      if (shouldShow) {
        // Force remove the hide class
        wrapper.classList.remove('hide');
        // Clear any inline display/visibility/opacity styles that might hide it
        wrapper.style.removeProperty('display');
        wrapper.style.removeProperty('visibility');
        wrapper.style.removeProperty('opacity');
      } else {
        wrapper.classList.add('hide');
      }
    });
  }

  clearContainers(){
    this.linked_containers_list.forEach((container) => {
      container.innerHTML = ''
    })
  }
  /*
   * ##################################
   * RENDERING
   * ##################################
   */
  // Method to render color options for the linked products
  renderLinkedProductOptions(matchingProduct) {
    if(!this.linked_containers_list.length) return
    this.clearContainers()

    const baseFileUrl = window.baseFileUrl // Base file URL for images

    const optionsObj = this.activeLabels.reduce((acc, el) => {
      acc[el.dataset.linkedLabel] = []
      return acc
    },{})

    this.active_labels_obj = this.activeLabels.reduce((acc, el) => {
      if(matchingProduct){
        const { metafields } = matchingProduct
        acc[el.dataset.linkedLabel] = metafields[el.dataset.linkedLabel].value
      } else {
        acc[el.dataset.linkedLabel] = el.textContent
      } 
      return acc
    },{})

    this.linked_containers_obj = this.linked_containers_list.reduce((acc, container) => ({ ...acc, [container.dataset.linkedProductContainer]: container}), {}) 
    
    this.active_label_els = this.activeLabels.reduce((acc, el) => ({ ...acc, [el.dataset.linkedLabel]: el}), {}) 

    const availableOptionsObj = this.getOptions(optionsObj);

    for(const type in availableOptionsObj){
      this.sortSpecialChar(availableOptionsObj[type].sort((a, b) => a.value.localeCompare(b.value, undefined, { numeric: true })))
    }

    for(const type in availableOptionsObj){
      availableOptionsObj[type].sort((a, b) => {
        const priorityA = a.order_priority !== undefined ? a.order_priority : Infinity; // Default for missing priority
        const priorityB = b.order_priority !== undefined ? b.order_priority : Infinity;

        return priorityA - priorityB;
      });
    }
    
    let top_level_index = 0
    let data_index = 0
    const numberOfOptions = Object.keys(availableOptionsObj).length;
    for(const type in availableOptionsObj){
      let top_level_option = !top_level_index
      availableOptionsObj[type].forEach((option, index) => {
        const { value } = option
        if(top_level_option) top_level_option = value
        if(type == 'color') {
          const element = this.createSwatchElement(value, data_index, baseFileUrl, this.productColorLabel, type, top_level_option, numberOfOptions)
          if(element){
            this.linked_containers_obj[type].appendChild(element)
            let selectedIndex = this.linked_containers_obj[type].querySelector('input:checked')?.dataset.index
            if(selectedIndex) this.productColorLabel.setAttribute('data-selected-index', selectedIndex)
              data_index++
            }
        } else {
          const element = this.createOptionElement(value, type, top_level_option, numberOfOptions)
          if(element)this.linked_containers_obj[type].appendChild(element)
          }
      })
      top_level_index++
    }

    this.syncOptionAriaStates()
  }

  customSort = function (a, b) {
    return (Number(a.match(/(\d+)/g)[0]) - Number((b.match(/(\d+)/g)[0])));
  }

  sortSpecialChar(array){
    let special_chars = 0
    let element = false
    array.forEach((el, i) => {
      if(el.value.includes("&")){
        special_chars++
        element = el
      }
    })
    if(special_chars == 1){
      const index = array.indexOf(element)
      array.push(array.splice(index, 1)[0])
    }
    return array
  }

  // Method to create a list item for each color option
  createSwatchElement(colorOption, index, baseFileUrl, colorLabel, type, top_level_option, numberOfOptions) {
    const state = {...this.active_labels_obj}
    state[type] = colorOption
    const dataElement = this.getMatchingProduct(state)
    if(!dataElement && !top_level_option) return false
    if(top_level_option && !this.isOptionAvailable(state, top_level_option)) return false
    let variantAvailable = dataElement?.available 
    if(!variantAvailable && numberOfOptions < 2) return false
    if(dataElement && !variantAvailable && numberOfOptions > 1 && !top_level_option) return false
    let variantId = dataElement?.variants[0].id
    let colorFiltered = `${colorOption.toLowerCase().split(' ').join('-')}`
    let colorLabelSelected = this.active_labels_obj[type]
    const swatchElement = document.createElement('div')
    swatchElement.classList.add('swatch-element', 'color', colorFiltered)
    swatchElement.setAttribute('data-value', colorOption)
    swatchElement.setAttribute('data-option-type', type)
    swatchElement.setAttribute('role', 'radio')
    swatchElement.setAttribute('tabindex', '0')
    swatchElement.setAttribute('aria-checked', colorOption === colorLabelSelected ? 'true' : 'false')
    swatchElement.setAttribute('aria-label', colorOption)
    if(!dataElement && top_level_option && this.isOptionAvailable(state, top_level_option)){
      swatchElement.addEventListener('click', (e) => this.handleUnavailableOptionClick(e, this))
    } else {
      swatchElement.addEventListener('click', this.handleOptionClick.bind(this))
    }
    swatchElement.addEventListener('keydown', this.handleOptionKeydown.bind(this))
    swatchElement.innerHTML = this.getListItemHTML(colorOption, index, `color-${colorFiltered}`, colorFiltered, variantId, colorLabelSelected)
    return swatchElement
  }

  // Method to create a list item for each option
  createOptionElement(option, type, top_level_option, numberOfOptions) {
    const state = {...this.active_labels_obj}
    state[type] = option
    const dataElement = this.getMatchingProduct(state)
    if(!dataElement && !top_level_option) return false
    if(top_level_option && !this.isOptionAvailable(state, top_level_option)) return false
    let variantAvailable = dataElement?.available
    if(!variantAvailable && numberOfOptions < 2) return false
    if(dataElement && !variantAvailable && numberOfOptions > 1 && !top_level_option) return false
    const element = document.createElement('button')
    element.classList.add('variant-option', this.active_labels_obj[type] === option ? 'active' : 'inactive')
    element.type = 'button'
    element.setAttribute('data-value', option)
    element.setAttribute('data-option-type', type)
    element.setAttribute('role', 'radio')
    element.setAttribute('aria-checked', this.active_labels_obj[type] === option ? 'true' : 'false')
    element.setAttribute('tabindex', this.active_labels_obj[type] === option ? '0' : '-1')
    if(!dataElement && top_level_option && this.isOptionAvailable(state, top_level_option)){
      element.addEventListener('click', (e) => this.handleUnavailableOptionClick(e, this))
    } else {
      element.addEventListener('click', this.handleOptionClick.bind(this))
    }
    element.addEventListener('keydown', this.handleButtonRadioKeydown.bind(this))
    element.textContent = option
    if(!variantAvailable && !top_level_option){
      element.disabled = true
      element.setAttribute('aria-disabled', 'true')
    }
    return element
  }

  // Method to return HTML for list item
  getListItemHTML(colorOption, index, colorClass, colorFiltered, variantId, colorLabelSelected) {
    return `
    <div class="tooltip" aria-hidden="true" data-color-label>${colorOption}</div>
      <input
        class="visuallyhidden"
        id="swatch-${variantId}-${index}-${colorFiltered}"
        type="radio"
        name="option-${index}"
        value="${colorOption}"
        data-index="${index}"
        ${colorOption === colorLabelSelected ? 'checked' : ''}
        role="presentation"
        tabindex="-1"
        aria-hidden="true"
      >
      <label
        class="animation color ${colorClass}"
        role="presentation"
        for="swatch-${variantId}-${index}-${colorFiltered}"
        tabindex="-1"
      >
        <span class="visuallyhidden"
          >Select ${colorOption}
        </span>
        <div class="cross"></div>
      </label>
    </div>
    `
  }

  // Method to render addon products for the linked products
  renderAddonProductOptions() {
    let state = {...this.active_labels_obj}
    let matchingProduct = this.getMatchingProduct(state)
    if (!this.productAddonsContainer || !matchingProduct) return;
    this.productAddonsContainer.innerHTML = ''; // Clear the existing options
    const {addons:addonOptions=[] } = matchingProduct
    // Check if addonOptions at selectedIndex exists
    if (addonOptions.length > 0) {
        this.productAddonsHeading.classList.remove('hide');
        
        addonOptions.forEach((addonOption) => {
            const addonItem = this.createAddonItem(addonOption);
            this.productAddonsContainer.appendChild(addonItem);

            let contents = this.productAddonsContainer.querySelectorAll('.addon-recommendations__content');
            let min_height = 0
    
            if(contents){
            contents.forEach(content => {
                if (content.offsetHeight > min_height){
                  min_height = content.offsetHeight;
                }
              })
              let root = document.querySelector(':root');
              root.style.setProperty('--addon-content-height', min_height + "px")
            }

        });
    } else {
        this.productAddonsHeading.classList.add('hide');
    }
  }

  // Method to create a list item for each color option
  createAddonItem(addonOption) {
    let addonAvailable = addonOption.main_variant.available
    if (!addonAvailable) {
      addonAvailable = 'hide'
    }
    let addonId = addonOption.main_variant.id
    let addonImgSrc = addonOption.main_image[0].src
    let addonImgAlt = addonOption.main_image[0].alt.replace(/"/g, '&quot;')
    let addonTitle
    if (addonOption.main_variant.title === "Default Title") {
      addonTitle = addonOption.main_product.title.replace(/"/g, '&quot;')
    } else {
      addonTitle = addonOption.main_product.title.replace(/"/g, '&quot;') + " - " + addonOption.main_variant.title.replace(/"/g, '&quot;')
    }
  
    function cleanTitle(title) {
      const match = title.match(/^(.+)\|\s*([^-]+)\s*-\s*\2$/);
      if (match) {
        return match[1].trim() + '| ' + match[2].trim();
      }
      return title;
    }
  
    addonTitle = cleanTitle(addonTitle);
    
    let addonPrice = addonOption.main_price
    const addonItem = document.createElement('div')
    addonItem.classList.add('addon-recommendations__item', addonAvailable)
    addonItem.innerHTML = this.getAddonItemHTML(addonId, addonTitle, addonPrice, addonImgSrc, addonImgAlt)
    const productsUrl = this.productAddonsContainer.closest('.addon-recommendations').dataset.productsUrl
    const addonUrl = `${productsUrl}${encodeURIComponent(addonOption.main_product.handle)}?variant=${addonId}`
    for (const [selector, className] of [
      ['img', 'addon-recommendations__image-link'],
      ['.addon-recommendations__title', 'addon-recommendations__title-link']
    ]) {
      const element = addonItem.querySelector(selector)
      const link = document.createElement('a')
      link.href = addonUrl
      link.className = className
      if (selector === 'img') link.setAttribute('aria-label', `View ${addonOption.main_product.title}`)
      element.replaceWith(link)
      link.appendChild(element)
    }
    if (this.productAddonsContainer.closest('.addon-recommendations')?.dataset.showLearnMore === 'true') {
      const link = document.createElement('a')
      link.className = 'addon-recommendations__learn-more'
      link.href = addonUrl
      link.textContent = 'Learn More'
      link.setAttribute('aria-label', `Learn more about ${addonOption.main_product.title}`)
      addonItem.querySelector('.addon-recommendations__content').appendChild(link)
    }
    return addonItem
  }  

  // Method to return HTML for list item
  getAddonItemHTML(addonId, addonTitle, addonPrice, addonImgSrc, addonImgAlt) {
    return `
    <img src="${addonImgSrc}" alt="${addonImgAlt}" height="100" width="100">
    <div class="addon-recommendations__content">
      <p class="addon-recommendations__title">
        ${addonTitle}
      </p>
      <p class="addon-recommendations__price">
        ${addonPrice}
      </p>
      <form
        method="post"
        class="variants add-to-cart-form"
        enctype="multipart/form-data"
      >
        <input type="hidden" name="id" value="${addonId}">
        <input type="hidden" name="quantity" value="1">
        <button type="submit" name="add" class="btn">Add to cart</button>
      </form>
    </div>
    `
  }

  /*
   * ##################################
   * URL MANAGEMENT
   * ##################################
   */
  // Method to generate a new URL based on the product title associated with the selected color
  buildNewUrl(state, matchingProduct) {
    if (!matchingProduct) return
    const url = matchingProduct.url
    return `${window.location.origin}${url}`
  }

  /*
   * ##################################
   * STATE MANAGEMENT
   * ##################################
   */
  // Method to update the state of the page based on the selected color
  updatePageState(state) {
    for(const option in state){
      if(option === 'color'){
        const matchingOption = this.linked_containers_obj[option] && this.linked_containers_obj[option].querySelector(`input[value="${state[option]}"]`)
        this.updateActiveOption(matchingOption, option)
      } else {
        const matchingOption = this.linked_containers_obj[option] && this.linked_containers_obj[option].querySelector(`button[data-value='${state[option]}']`)
        this.updateActiveOption(matchingOption, option)
      }
    }
  }
}

// Function to initialize the page
const initializePage = () => {
  const handler = new LinkedProducts('linked-products-json');
  handler.initializeData();
  handler.renderLinkedProductOptions();
  handler.renderAddonProductOptions()
}

window.onload = initializePage;
